/* eslint-disable react-hooks/exhaustive-deps */

import { AxiosError } from "axios";
import api from "../../../../services/api";
import { useEffect, useRef, useState } from "react";
import Listagem, { ConfiguracaoFiltros } from "../../../../components/listagem";
import ModalAlerta from "../../../../components/modal";
import { useAppSelector } from "../../../../store/hooks";
import { useSelector } from "react-redux";
import { ApiError, EmpresaAdmin } from "../../../../services/tipos";
import { LocaSmartLayout } from "../../../../components/locasmart-layout";
import ModalAlertaTemporario from "../../../../components/modal-temporario";
import { tratarErroApi } from "../../../../services/utilitarios";
import { usuarioTemPermissao } from "../../../../services/seguranca";
import { MdBusiness, MdBlock, MdInfoOutline, MdLanguage, MdCheckCircle, MdErrorOutline, MdContentCopy, MdOpenInNew, MdSecurity, MdEdit } from "react-icons/md";
import { FaRocket, FaCheckCircle, FaEdit, FaCog, FaSyncAlt, FaSatelliteDish, FaFlask, FaWhatsapp } from "react-icons/fa";
import { toast } from "react-toastify";
import { confirm } from "../../../../components/confirm";
import { GridColDef } from "@mui/x-data-grid";
import { Tab, Tabs } from "@mui/material";
import { listarSaquesPendentes, aprovarSaque, rejeitarSaque, listarSaquesReconciliacao, confirmarPagoSaque, estornarSaque, SolicitacaoSaqueDto } from "../../../../services/afiliacao";
import { obterConfiguracaoIss, definirConfiguracaoIss } from "../../../../services/parametroSistema";
import ConsumoAssistente from "./consumo-assistente";

const ADMIN_EMPRESA_ID = "f5ec617c-48b1-4e42-a3e9-c545c974f31a";

// Conciliacao Asaas por empresa (preview + aprovacao)
interface AcaoConciliacaoAsaas {
    tipo: number;
    idLocacao: string;
    descricao: string;
    asaasPaymentId: string;
    vencimento: string;
    valor: number;
    statusAsaas: string;
    idParcelaLocal: string | null;
    motivo: string;
    dataPagamentoLocal: string | null;
    dataPagamentoAsaas: string | null;
}

interface ResultadoAplicarConciliacaoAsaas {
    acao: AcaoConciliacaoAsaas;
    aplicada: boolean;
    resultado: string;
}

// Espelha PreviewConciliacaoStatusDto do backend (serializado em camelCase).
interface StatusPreviewConciliacaoAsaas {
    idAnalise: string;
    idEmpresa: string;
    totalLocacoes: number;
    locacoesAnalisadas: number;
    concluido: boolean;
    erro: string | null;
    acoes: AcaoConciliacaoAsaas[] | null;
}

const ROTULOS_ACAO_CONCILIACAO: Record<number, string> = {
    0: 'Criar parcela',
    1: 'Vincular parcela',
    2: 'Vincular (paga) e baixar no Asaas',
    3: 'Divergencia',
};

// Espelha ConciliarJurosMultaAsaasResultadoDto do backend (serializado em camelCase).
interface ConciliarJurosMultaItem {
    idLocacao: string;
    placa?: string | null;
    flagAnterior: boolean;
    flagNovo: boolean;
    asaasSincronizado: boolean;
}

interface ConciliarJurosMultaResultado {
    totalVarridas: number;
    totalFlagCorrigido: number;
    totalAsaasSincronizadas: number;
    detalhes: ConciliarJurosMultaItem[];
    falhas: string[];
}

function FilaSaques() {
    const [saques, setSaques] = useState<SolicitacaoSaqueDto[]>([]);
    const [carregando, setCarregando] = useState(false);

    const carregar = async () => {
        setCarregando(true);
        try {
            const res = await listarSaquesPendentes();
            setSaques(res.data);
        } catch {
            toast.error("Erro ao carregar saques pendentes");
        } finally {
            setCarregando(false);
        }
    };

    useEffect(() => { carregar(); }, []);

    const handleAprovar = async (saque: SolicitacaoSaqueDto) => {
        if (!await confirm(`Aprovar saque de R$ ${saque.valor.toLocaleString('pt-BR', { minimumFractionDigits: 2 })} para ${saque.nomeEmpresa}?`)) return;
        try {
            await aprovarSaque(saque.id);
            toast.success("Saque aprovado!");
            carregar();
        } catch {
            toast.error("Erro ao aprovar saque");
        }
    };

    const handleRejeitar = async (saque: SolicitacaoSaqueDto) => {
        const motivo = window.prompt(`Motivo da rejeição para ${saque.nomeEmpresa}:`);
        if (!motivo) return;
        try {
            await rejeitarSaque(saque.id, motivo);
            toast.success("Saque rejeitado!");
            carregar();
        } catch {
            toast.error("Erro ao rejeitar saque");
        }
    };

    if (carregando) return <p style={{ padding: 16 }}>Carregando...</p>;

    return (
        <div style={{ padding: 8 }}>
            {saques.length === 0 ? (
                <p style={{ color: '#666', padding: 16 }}>Nenhum saque pendente.</p>
            ) : (
                <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.9rem' }}>
                    <thead>
                        <tr style={{ background: '#f5f5f5' }}>
                            <th style={{ padding: '8px 12px', textAlign: 'left', borderBottom: '1px solid #e0e0e0' }}>Empresa</th>
                            <th style={{ padding: '8px 12px', textAlign: 'right', borderBottom: '1px solid #e0e0e0' }}>Valor</th>
                            <th style={{ padding: '8px 12px', textAlign: 'left', borderBottom: '1px solid #e0e0e0' }}>Chave PIX</th>
                            <th style={{ padding: '8px 12px', textAlign: 'left', borderBottom: '1px solid #e0e0e0' }}>Data</th>
                            <th style={{ padding: '8px 12px', textAlign: 'center', borderBottom: '1px solid #e0e0e0' }}>Ações</th>
                        </tr>
                    </thead>
                    <tbody>
                        {saques.map(s => (
                            <tr key={s.id} style={{ borderBottom: '1px solid #f0f0f0' }}>
                                <td style={{ padding: '8px 12px' }}>{s.nomeEmpresa}</td>
                                <td style={{ padding: '8px 12px', textAlign: 'right' }}>
                                    {s.valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                                </td>
                                <td style={{ padding: '8px 12px' }}>{s.chavePix}</td>
                                <td style={{ padding: '8px 12px' }}>
                                    {new Date(s.dataSolicitacao).toLocaleString('pt-BR')}
                                </td>
                                <td style={{ padding: '8px 12px', textAlign: 'center' }}>
                                    <button
                                        onClick={() => handleAprovar(s)}
                                        style={{ marginRight: 8, padding: '4px 12px', background: '#2e7d32', color: '#fff', border: 'none', borderRadius: 4, cursor: 'pointer', fontSize: '0.82rem', fontWeight: 600 }}
                                    >
                                        Aprovar
                                    </button>
                                    <button
                                        onClick={() => handleRejeitar(s)}
                                        style={{ padding: '4px 12px', background: '#c62828', color: '#fff', border: 'none', borderRadius: 4, cursor: 'pointer', fontSize: '0.82rem', fontWeight: 600 }}
                                    >
                                        Rejeitar
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
        </div>
    );
}

function FilaReconciliacao() {
    const [saques, setSaques] = useState<SolicitacaoSaqueDto[]>([]);
    const [carregando, setCarregando] = useState(false);

    const carregar = async () => {
        setCarregando(true);
        try {
            const res = await listarSaquesReconciliacao();
            setSaques(res.data);
        } catch {
            toast.error("Erro ao carregar saques em reconciliação");
        } finally {
            setCarregando(false);
        }
    };

    useEffect(() => { carregar(); }, []);

    const handleConfirmarPago = async (saque: SolicitacaoSaqueDto) => {
        if (!await confirm(`Confirmar que o PIX de R$ ${saque.valor.toLocaleString('pt-BR', { minimumFractionDigits: 2 })} para ${saque.nomeEmpresa} SAIU no Asaas? O saque será marcado como Pago.`)) return;
        try {
            await confirmarPagoSaque(saque.id);
            toast.success("Saque marcado como pago!");
            carregar();
        } catch {
            toast.error("Erro ao confirmar pagamento");
        }
    };

    const handleEstornar = async (saque: SolicitacaoSaqueDto) => {
        const motivo = window.prompt(`Confirme que o PIX para ${saque.nomeEmpresa} NÃO saiu. Motivo do estorno:`);
        if (!motivo) return;
        try {
            await estornarSaque(saque.id, motivo);
            toast.success("Saque estornado e saldo devolvido!");
            carregar();
        } catch {
            toast.error("Erro ao estornar saque");
        }
    };

    if (carregando) return <p style={{ padding: 16 }}>Carregando...</p>;

    return (
        <div style={{ padding: 8 }}>
            <p style={{ color: '#8a6d00', background: '#fff8e1', border: '1px solid #ffe082', borderRadius: 6, padding: '8px 12px', fontSize: '0.85rem', margin: '0 0 12px' }}>
                Estes saques tiveram envio PIX com resultado <strong>ambíguo</strong> (timeout/erro do Asaas) e não foram estornados automaticamente para evitar pagamento em dobro.
                Verifique no painel do Asaas se a transferência saiu e resolva cada caso.
            </p>
            {saques.length === 0 ? (
                <p style={{ color: '#666', padding: 16 }}>Nenhum saque aguardando reconciliação.</p>
            ) : (
                <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.9rem' }}>
                    <thead>
                        <tr style={{ background: '#f5f5f5' }}>
                            <th style={{ padding: '8px 12px', textAlign: 'left', borderBottom: '1px solid #e0e0e0' }}>Empresa</th>
                            <th style={{ padding: '8px 12px', textAlign: 'right', borderBottom: '1px solid #e0e0e0' }}>Valor</th>
                            <th style={{ padding: '8px 12px', textAlign: 'left', borderBottom: '1px solid #e0e0e0' }}>Chave PIX</th>
                            <th style={{ padding: '8px 12px', textAlign: 'left', borderBottom: '1px solid #e0e0e0' }}>Data</th>
                            <th style={{ padding: '8px 12px', textAlign: 'left', borderBottom: '1px solid #e0e0e0' }}>Motivo</th>
                            <th style={{ padding: '8px 12px', textAlign: 'center', borderBottom: '1px solid #e0e0e0' }}>Ações</th>
                        </tr>
                    </thead>
                    <tbody>
                        {saques.map(s => (
                            <tr key={s.id} style={{ borderBottom: '1px solid #f0f0f0' }}>
                                <td style={{ padding: '8px 12px' }}>{s.nomeEmpresa}</td>
                                <td style={{ padding: '8px 12px', textAlign: 'right' }}>
                                    {s.valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                                </td>
                                <td style={{ padding: '8px 12px' }}>{s.chavePix}</td>
                                <td style={{ padding: '8px 12px' }}>
                                    {new Date(s.dataSolicitacao).toLocaleString('pt-BR')}
                                </td>
                                <td style={{ padding: '8px 12px', color: '#8a6d00', fontSize: '0.8rem', maxWidth: 220 }}>{s.motivoRejeicao}</td>
                                <td style={{ padding: '8px 12px', textAlign: 'center', whiteSpace: 'nowrap' }}>
                                    <button
                                        onClick={() => handleConfirmarPago(s)}
                                        style={{ marginRight: 8, padding: '4px 12px', background: '#2e7d32', color: '#fff', border: 'none', borderRadius: 4, cursor: 'pointer', fontSize: '0.82rem', fontWeight: 600 }}
                                    >
                                        Confirmar Pago
                                    </button>
                                    <button
                                        onClick={() => handleEstornar(s)}
                                        style={{ padding: '4px 12px', background: '#c62828', color: '#fff', border: 'none', borderRadius: 4, cursor: 'pointer', fontSize: '0.82rem', fontWeight: 600 }}
                                    >
                                        Estornar
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
        </div>
    );
}

function ConfiguracoesSistema() {
    const [aliquota, setAliquota] = useState<string>("");
    const [carregando, setCarregando] = useState(false);
    const [salvando, setSalvando] = useState(false);

    useEffect(() => {
        (async () => {
            setCarregando(true);
            try {
                const res = await obterConfiguracaoIss();
                setAliquota(String(res.data.aliquotaIss ?? ""));
            } catch {
                toast.error("Erro ao carregar a alíquota de ISS");
            } finally {
                setCarregando(false);
            }
        })();
    }, []);

    const salvar = async () => {
        const valor = Number(aliquota.replace(",", "."));
        if (Number.isNaN(valor) || valor < 0 || valor > 100) {
            toast.error("Informe uma alíquota válida entre 0 e 100.");
            return;
        }
        setSalvando(true);
        try {
            await definirConfiguracaoIss(valor);
            toast.success("Alíquota de ISS atualizada!");
        } catch {
            toast.error("Erro ao salvar a alíquota de ISS");
        } finally {
            setSalvando(false);
        }
    };

    if (carregando) return <p style={{ padding: 16 }}>Carregando...</p>;

    return (
        <div style={{ padding: 16, maxWidth: 420 }}>
            <h3 style={{ margin: "0 0 4px", fontSize: "1rem", fontWeight: 700, color: "#0f2544" }}>
                Alíquota de ISS (%)
            </h3>
            <p style={{ margin: "0 0 12px", fontSize: "0.85rem", color: "#666" }}>
                Usada na emissão das notas fiscais (NFS-e) das assinaturas da plataforma.
            </p>
            <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                <input
                    type="number"
                    step="0.01"
                    min={0}
                    max={100}
                    value={aliquota}
                    onChange={(e) => setAliquota(e.target.value)}
                    style={{ width: 120, padding: "8px 10px", border: "1px solid #d7dee8", borderRadius: 6, fontSize: "0.95rem" }}
                />
                <button
                    onClick={salvar}
                    disabled={salvando}
                    style={{ padding: "8px 18px", background: "#1F467E", color: "#fff", border: "none", borderRadius: 6, cursor: salvando ? "default" : "pointer", fontSize: "0.9rem", fontWeight: 600, opacity: salvando ? 0.6 : 1 }}
                >
                    {salvando ? "Salvando..." : "Salvar"}
                </button>
            </div>
        </div>
    );
}

function EmpresaListagem() {
    const tenantId = useSelector((state: any) => state.tenantId);
    const isAdmin = tenantId === ADMIN_EMPRESA_ID;
    const [aba, setAba] = useState(0);

    const [empresas, setEmpresas] = useState<EmpresaAdmin[]>([]);
    const [showAlerta, setShowAlerta] = useState(false);
    const [carregando, setCarregando] = useState<boolean>(false);
    const [token] = useState(useAppSelector(state => state.token));
    const [messageAlerta, setMessageAlerta] = useState<string[]>([]);
    const [messageAlertaTemporario, setMessageAlertaTemporario] = useState<string[]>([]);
    const [exibirFormModalTemporario, setExibirFormModalTemporario] = useState<boolean>(false);

    // Paginacao server-side
    const [rowCount, setRowCount] = useState(0);
    const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 25 });

    // Filtros
    const [filtroNome, setFiltroNome] = useState<string>("");
    const [filtroEmail, setFiltroEmail] = useState<string>("");
    const [filtroStatus, setFiltroStatus] = useState<string>("");
    const [filtroTipoPlano, setFiltroTipoPlano] = useState<string>("");
    const [filtroAtiva, setFiltroAtiva] = useState<string>("");

    // Modal ativar empresa
    const [showModalAtivar, setShowModalAtivar] = useState(false);
    const [empresaParaAtivar, setEmpresaParaAtivar] = useState<EmpresaAdmin | null>(null);
    const [ativarTipoPlano, setAtivarTipoPlano] = useState<string>("PRO");
    const [ativarLimiteVeiculos, setAtivarLimiteVeiculos] = useState<number>(5);
    const [ativarExpiraEm, setAtivarExpiraEm] = useState<string>("");
    const [carregandoAtivar, setCarregandoAtivar] = useState<boolean>(false);
    const [ativarLocaSmartTrack, setAtivarLocaSmartTrack] = useState<boolean>(false);
    const [showModalConfirmarTrack, setShowModalConfirmarTrack] = useState<boolean>(false);

    // Modal editar empresa
    const [showModalEditar, setShowModalEditar] = useState(false);
    const [empresaParaEditar, setEmpresaParaEditar] = useState<EmpresaAdmin | null>(null);
    const [editarNome, setEditarNome] = useState("");
    const [editarDocumento, setEditarDocumento] = useState("");
    const [editarUsuarios, setEditarUsuarios] = useState<{ id: string; nome: string; email: string; senha: string; administrador: boolean }[]>([]);
    const [carregandoEditar, setCarregandoEditar] = useState(false);
    const [carregandoUsuarios, setCarregandoUsuarios] = useState(false);
    const [senhasReveladas, setSenhasReveladas] = useState<Record<string, boolean>>({});
    const [novasSenhas, setNovasSenhas] = useState<Record<string, string>>({});
    const [salvandoUsuarioId, setSalvandoUsuarioId] = useState<string | null>(null);

    // Modal configuracoes (limites + NFSe)
    const [showModalConfig, setShowModalConfig] = useState(false);
    const [empresaParaConfig, setEmpresaParaConfig] = useState<EmpresaAdmin | null>(null);
    const [configLimiteVeiculos, setConfigLimiteVeiculos] = useState<number>(5);
    const [configNfseAtiva, setConfigNfseAtiva] = useState<boolean>(false);
    const [configLimiteNf, setConfigLimiteNf] = useState<number>(100);
    const [carregandoConfig, setCarregandoConfig] = useState<boolean>(false);

    // Modal sandbox Asaas (ambiente de testes do suporte)
    const [showModalSandbox, setShowModalSandbox] = useState(false);
    const [empresaParaSandbox, setEmpresaParaSandbox] = useState<EmpresaAdmin | null>(null);
    const [sandboxHabilitado, setSandboxHabilitado] = useState<boolean>(false);
    const [sandboxChave, setSandboxChave] = useState<string>("");
    const [sandboxChaveConfigurada, setSandboxChaveConfigurada] = useState<boolean>(false);
    const [mostrarSandboxChave, setMostrarSandboxChave] = useState<boolean>(false);
    const [carregandoSandbox, setCarregandoSandbox] = useState<boolean>(false);
    const [salvandoSandbox, setSalvandoSandbox] = useState<boolean>(false);

    const [empresaParaAssistente, setEmpresaParaAssistente] = useState<EmpresaAdmin | null>(null);
    // 0 = desligado; 1 básico, 2 intermediário, 3 avançado
    const [assistenteNivel, setAssistenteNivel] = useState<number>(0);
    // 1 Haiku, 2 Sonnet, 3 Opus
    const [assistenteModelo, setAssistenteModelo] = useState<number>(3);
    // vazio = sem limite
    const [assistenteLimiteDia, setAssistenteLimiteDia] = useState<string>('');
    const [carregandoAssistente, setCarregandoAssistente] = useState<boolean>(false);
    const [salvandoAssistente, setSalvandoAssistente] = useState<boolean>(false);

    // Modal site da locadora
    const [showModalSite, setShowModalSite] = useState(false);
    const [empresaParaSite, setEmpresaParaSite] = useState<EmpresaAdmin | null>(null);
    const [siteExistente, setSiteExistente] = useState<{ slug: string; categoria: number; publicado: boolean } | null>(null);
    const [carregandoSite, setCarregandoSite] = useState(false);
    const [siteSlug, setSiteSlug] = useState("");
    const [siteCategoria, setSiteCategoria] = useState<number>(1);
    const [slugDisponivel, setSlugDisponivel] = useState<boolean | null>(null);
    const [verificandoSlug, setVerificandoSlug] = useState(false);
    const [gerandoSite, setGerandoSite] = useState(false);
    const [alterandoPublicacao, setAlterandoPublicacao] = useState(false);
    const [regerandoConteudo, setRegerandoConteudo] = useState(false);
    const [editandoSlug, setEditandoSlug] = useState(false);
    const [novoSlug, setNovoSlug] = useState("");
    const [novoSlugDisponivel, setNovoSlugDisponivel] = useState<boolean | null>(null);
    const [verificandoNovoSlug, setVerificandoNovoSlug] = useState(false);
    const [salvandoSlug, setSalvandoSlug] = useState(false);

    // Modal conciliacao de juros/multa no Asaas
    const [carregandoConciliar, setCarregandoConciliar] = useState<boolean>(false);
    const [empresaConciliando, setEmpresaConciliando] = useState<EmpresaAdmin | null>(null);
    const [resultadoConciliar, setResultadoConciliar] = useState<ConciliarJurosMultaResultado | null>(null);

    // Modal conciliacao Asaas por empresa (preview + aprovacao)
    const [showModalConciliacaoAsaas, setShowModalConciliacaoAsaas] = useState<boolean>(false);
    const [empresaConciliacaoAsaas, setEmpresaConciliacaoAsaas] = useState<EmpresaAdmin | null>(null);
    const [conciliacaoDataCorte, setConciliacaoDataCorte] = useState<string>(new Date().toISOString().slice(0, 10));
    const [carregandoPreviewConciliacao, setCarregandoPreviewConciliacao] = useState<boolean>(false);
    const [progressoPreviewConciliacao, setProgressoPreviewConciliacao] = useState<{ analisadas: number; total: number } | null>(null);
    const [acoesPreviewConciliacao, setAcoesPreviewConciliacao] = useState<AcaoConciliacaoAsaas[] | null>(null);
    const [acoesSelecaoIds, setAcoesSelecaoIds] = useState<Set<number>>(new Set());
    const [carregandoAplicarConciliacao, setCarregandoAplicarConciliacao] = useState<boolean>(false);
    const previewConciliacaoCanceladoRef = useRef<boolean>(false);

    const temPermissao = usuarioTemPermissao(token, 'empresa_visualizar');

    const formatarData = (valor: string) => {
        if (!valor) return "-";
        const date = new Date(valor);
        return date.toLocaleString("pt-BR", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit"
        });
    };

    const colunas: GridColDef[] = [
        { field: 'nome', headerName: 'Nome', flex: 1, minWidth: 150 },
        { field: 'documento', headerName: 'Documento', flex: 0.8, minWidth: 130 },
        { field: 'emailAdmin', headerName: 'E-mail Admin', flex: 1, minWidth: 180 },
        {
            field: 'tipoPlano', headerName: 'Plano', flex: 0.5, minWidth: 90,
            renderCell: (params: any) => {
                const val = params.value;
                if (!val) return <span style={{ color: '#999' }}>-</span>;
                return <span style={{ fontWeight: 600 }}>{val}</span>;
            }
        },
        {
            field: 'status', headerName: 'Status', flex: 0.5, minWidth: 90,
            valueGetter: (params: any) => {
                const row = params.row;
                if (row.emPeriodoDeTeste) return 'Teste';
                if (row.planoGratuito) return 'Gratuito';
                return 'Pago';
            },
            renderCell: (params: any) => {
                const val = params.value;
                let bg = '#e0e0e0'; let color = '#333';
                if (val === 'Pago') { bg = '#c8e6c9'; color = '#2e7d32'; }
                if (val === 'Gratuito') { bg = '#fff3e0'; color = '#e65100'; }
                if (val === 'Teste') { bg = '#e3f2fd'; color = '#1565c0'; }
                return (
                    <span style={{ backgroundColor: bg, color, padding: '2px 8px', borderRadius: '12px', fontSize: '0.75rem', fontWeight: 600 }}>
                        {val}
                    </span>
                );
            }
        },
        {
            field: 'treinamentoStatus',
            headerName: 'Treinamento',
            flex: 0.7,
            sortable: false,
            renderCell: (params: any) => {
                const s = params.row?.treinamentoStatus;
                const base: any = { padding: '2px 8px', borderRadius: 12, fontWeight: 600, fontSize: 12, whiteSpace: 'nowrap' };
                if (s === 'Solicitado') return <span style={{ ...base, background: '#ffe3e3', color: '#c92a2a' }}>🔴 Solicitou</span>;
                if (s === 'JaTeve') return <span style={{ ...base, background: '#e6fcf5', color: '#087f5b' }}>✅ Já teve</span>;
                if (s === 'NaoPrecisa') return <span style={{ ...base, background: '#f1f3f5', color: '#495057', fontWeight: 500 }}>Não precisa</span>;
                return <span style={{ color: '#adb5bd' }}>—</span>;
            },
        },
        {
            field: 'ativa', headerName: 'Ativa', flex: 0.4, minWidth: 60,
            valueGetter: (params: any) => params.value ? 'Sim' : 'Nao'
        },
        {
            field: 'expiraEm', headerName: 'Expira Em', flex: 0.8, minWidth: 140,
            valueGetter: (params: any) => formatarData(params.value)
        },
        { field: 'limiteDeVeiculos', headerName: 'Lim. Veic.', flex: 0.4, minWidth: 80 },
        {
            field: 'emissaoNotaFiscalLiberada', headerName: 'NFSe', flex: 0.4, minWidth: 80,
            renderCell: (params: any) => (
                <span style={{
                    backgroundColor: params.value ? '#c8e6c9' : '#eeeeee',
                    color: params.value ? '#2e7d32' : '#777',
                    padding: '2px 8px', borderRadius: '12px', fontSize: '0.75rem', fontWeight: 600
                }}>
                    {params.value ? 'Ativa' : 'Inativa'}
                </span>
            )
        },
        {
            field: 'limiteNotasFiscais', headerName: 'Lim. NF', flex: 0.4, minWidth: 70,
            valueGetter: (params: any) => {
                if (!params.row.emissaoNotaFiscalLiberada) return '-';
                return params.value > 0 ? params.value : 'Ilimitado';
            }
        },
        { field: 'qtdUsuarios', headerName: 'Usuarios', flex: 0.4, minWidth: 80 },
        { field: 'qtdVeiculos', headerName: 'Veiculos', flex: 0.4, minWidth: 80 },
        {
            field: 'dataDeCadastro', headerName: 'Cadastro', flex: 0.7, minWidth: 130,
            valueGetter: (params: any) => formatarData(params.value)
        },
    ];

    const fetchEmpresas = async (page: number, pageSize: number) => {
        if (!temPermissao) {
            setCarregando(false);
            return;
        }

        setCarregando(true);
        try {
            const params = new URLSearchParams();
            params.append('page', String(page + 1));
            params.append('pageSize', String(pageSize));

            if (filtroNome) params.append('nome', filtroNome);
            if (filtroEmail) params.append('email', filtroEmail);

            if (filtroStatus === 'gratuito') params.append('planoGratuito', 'true');
            if (filtroStatus === 'pago') {
                params.append('planoGratuito', 'false');
                params.append('emPeriodoDeTeste', 'false');
            }
            if (filtroStatus === 'teste') params.append('emPeriodoDeTeste', 'true');

            if (filtroTipoPlano) params.append('tipoPlano', filtroTipoPlano);

            if (filtroAtiva === 'true') params.append('ativa', 'true');
            if (filtroAtiva === 'false') params.append('ativa', 'false');

            const response = await api.get(`/Empresa/admin/filtrar?${params.toString()}`);

            if (response.data.items) {
                setEmpresas(response.data.items);
                setRowCount(response.data.totalCount);
            } else {
                setEmpresas([]);
                setRowCount(0);
            }
        } catch (error: any) {
            const axiosError = error as AxiosError<ApiError>;
            setMessageAlerta(tratarErroApi(axiosError, 'Erro ao buscar empresas: '));
            setShowAlerta(true);
        } finally {
            setCarregando(false);
        }
    };

    useEffect(() => {
        fetchEmpresas(paginationModel.page, paginationModel.pageSize);
    }, [paginationModel]);

    const handleBuscar = () => {
        setPaginationModel(prev => ({ ...prev, page: 0 }));
        fetchEmpresas(0, paginationModel.pageSize);
    };

    const handleAbrirModalAtivar = (empresa: EmpresaAdmin) => {
        setEmpresaParaAtivar(empresa);
        setAtivarTipoPlano("PRO");
        setAtivarLimiteVeiculos(5);

        const dataExpiracao = new Date();
        dataExpiracao.setMonth(dataExpiracao.getMonth() + 1);
        setAtivarExpiraEm(dataExpiracao.toISOString().slice(0, 16));
        // Preserva o status atual de rastreio: reativar sem marcar não deve desligar uma flag já detectada.
        setAtivarLocaSmartTrack(!!(empresa as any).locaSmartTrack);

        setShowModalAtivar(true);
    };

    const handleClickConfirmarAtivar = () => {
        setShowModalConfirmarTrack(true);
    };

    const handleConfirmarAtivar = async (comLocaSmartTrack: boolean) => {
        if (!empresaParaAtivar) return;

        setCarregandoAtivar(true);
        try {
            await api.post(`/Empresa/admin/ativar/${empresaParaAtivar.id}`, {
                tipoPlano: ativarTipoPlano,
                limiteVeiculos: ativarLimiteVeiculos,
                expiraEm: new Date(ativarExpiraEm).toISOString(),
                locaSmartTrack: comLocaSmartTrack
            });

            setShowModalConfirmarTrack(false);
            setShowModalAtivar(false);
            setMessageAlertaTemporario(['Empresa ativada com sucesso!']);
            setExibirFormModalTemporario(true);
            fetchEmpresas(paginationModel.page, paginationModel.pageSize);
        } catch (error: any) {
            const axiosError = error as AxiosError<ApiError>;
            setMessageAlerta(tratarErroApi(axiosError, 'Erro ao ativar empresa: '));
            setShowAlerta(true);
        } finally {
            setCarregandoAtivar(false);
        }
    };

    const handleToggleLocaSmartTrack = async (empresa: any) => {
        const novoValor = !empresa.locaSmartTrack;
        if (!window.confirm(`${novoValor ? 'Marcar' : 'Desmarcar'} "${empresa.nome}" como cliente com LocaSmartTrack?`)) return;
        try {
            await api.post(`/Empresa/admin/locasmarttrack/${empresa.id}`, { ativar: novoValor });
            setMessageAlertaTemporario([`LocaSmartTrack ${novoValor ? 'ativado' : 'desativado'} com sucesso!`]);
            setExibirFormModalTemporario(true);
            fetchEmpresas(paginationModel.page, paginationModel.pageSize);
        } catch (error: any) {
            const axiosError = error as AxiosError<ApiError>;
            setMessageAlerta(tratarErroApi(axiosError, 'Erro ao atualizar LocaSmartTrack: '));
            setShowAlerta(true);
        }
    };

    const handleToggleGestaoRisco = async (empresa: any) => {
        const novoValor = !empresa.moduloGestaoRisco;
        if (!window.confirm(`${novoValor ? 'Habilitar' : 'Desabilitar'} o módulo de Gestão de Risco para "${empresa.nome}"?`)) return;
        try {
            await api.post(`/Empresa/admin/gestaorisco/${empresa.id}`, { ativar: novoValor });
            setMessageAlertaTemporario([`Módulo de Gestão de Risco ${novoValor ? 'habilitado' : 'desabilitado'} com sucesso!`]);
            setExibirFormModalTemporario(true);
            fetchEmpresas(paginationModel.page, paginationModel.pageSize);
        } catch (error: any) {
            const axiosError = error as AxiosError<ApiError>;
            setMessageAlerta(tratarErroApi(axiosError, 'Erro ao atualizar o módulo de Gestão de Risco: '));
            setShowAlerta(true);
        }
    };

    const configFiltros: ConfiguracaoFiltros = {
        carregando: carregando,
        aoBuscar: handleBuscar,
        textos: [
            {
                key: 'nome',
                label: 'Nome',
                placeholder: 'Buscar por nome...',
                value: filtroNome,
                onChange: setFiltroNome,
            },
            {
                key: 'email',
                label: 'E-mail',
                placeholder: 'Buscar por e-mail...',
                value: filtroEmail,
                onChange: setFiltroEmail,
            },
        ],
        dropdowns: [
            {
                key: 'status',
                label: 'Status',
                placeholder: 'Todos',
                opcoes: [
                    { label: 'Gratuito', value: 'gratuito' },
                    { label: 'Pago', value: 'pago' },
                    { label: 'Teste', value: 'teste' },
                ],
                value: filtroStatus,
                onChange: (val: any) => setFiltroStatus(val),
            },
            {
                key: 'tipoPlano',
                label: 'Plano',
                placeholder: 'Todos',
                opcoes: [
                    { label: 'PRO', value: 'PRO' },
                    { label: 'AVANCADO', value: 'AVANCADO' },
                ],
                value: filtroTipoPlano,
                onChange: (val: any) => setFiltroTipoPlano(val),
            },
            {
                key: 'ativa',
                label: 'Ativa',
                placeholder: 'Todas',
                opcoes: [
                    { label: 'Sim', value: 'true' },
                    { label: 'Nao', value: 'false' },
                ],
                value: filtroAtiva,
                onChange: (val: any) => setFiltroAtiva(val),
            },
        ]
    };

    const handleAbrirModalEditar = async (empresa: EmpresaAdmin) => {
        setEmpresaParaEditar(empresa);
        setEditarNome(empresa.nome || "");
        setEditarDocumento(empresa.documento || "");
        setEditarUsuarios([]);
        setSenhasReveladas({});
        setNovasSenhas({});
        setShowModalEditar(true);
        setCarregandoUsuarios(true);
        try {
            const res = await api.get(`/Empresa/admin/usuarios/${empresa.id}`);
            setEditarUsuarios(res.data);
        } catch {
            toast.error("Erro ao carregar usuários");
        } finally {
            setCarregandoUsuarios(false);
        }
    };

    const handleEmailUsuarioChange = (id: string, email: string) => {
        setEditarUsuarios(prev => prev.map(u => u.id === id ? { ...u, email } : u));
    };

    const handleNomeUsuarioChange = (id: string, nome: string) => {
        setEditarUsuarios(prev => prev.map(u => u.id === id ? { ...u, nome } : u));
    };

    const handleSalvarUsuario = async (u: { id: string; nome: string; email: string }) => {
        setSalvandoUsuarioId(u.id);
        try {
            await api.put(`/Empresa/admin/usuario/${u.id}`, { nome: u.nome, email: u.email });
            toast.success("Usuário atualizado!");
        } catch (error: any) {
            const axiosError = error as AxiosError<ApiError>;
            setMessageAlerta(tratarErroApi(axiosError, 'Erro ao salvar usuário: '));
            setShowAlerta(true);
        } finally {
            setSalvandoUsuarioId(null);
        }
    };

    const handleDefinirSenha = async (id: string) => {
        const nova = (novasSenhas[id] || '').trim();
        if (!nova) { toast.error('Informe a nova senha'); return; }
        setSalvandoUsuarioId(id);
        try {
            await api.put(`/Empresa/admin/usuario/${id}/senha`, { novaSenha: nova });
            toast.success("Senha redefinida!");
            setEditarUsuarios(prev => prev.map(u => u.id === id ? { ...u, senha: nova } : u));
            setNovasSenhas(prev => ({ ...prev, [id]: '' }));
        } catch (error: any) {
            const axiosError = error as AxiosError<ApiError>;
            setMessageAlerta(tratarErroApi(axiosError, 'Erro ao redefinir senha: '));
            setShowAlerta(true);
        } finally {
            setSalvandoUsuarioId(null);
        }
    };

    const handleConfirmarEditar = async () => {
        if (!empresaParaEditar) return;
        setCarregandoEditar(true);
        try {
            await api.put(`/Empresa/admin/editar/${empresaParaEditar.id}`, {
                nome: editarNome,
                documento: editarDocumento,
            });
            setShowModalEditar(false);
            toast.success("Empresa atualizada com sucesso!");
            fetchEmpresas(paginationModel.page, paginationModel.pageSize);
        } catch (error: any) {
            const axiosError = error as AxiosError<ApiError>;
            setMessageAlerta(tratarErroApi(axiosError, 'Erro ao editar empresa: '));
            setShowAlerta(true);
        } finally {
            setCarregandoEditar(false);
        }
    };

    const handleAbrirModalConfig = (empresa: EmpresaAdmin) => {
        setEmpresaParaConfig(empresa);
        setConfigLimiteVeiculos(empresa.limiteDeVeiculos ?? 5);
        setConfigNfseAtiva(empresa.emissaoNotaFiscalLiberada ?? false);
        // Sugerir 100 quando ainda nao houver limite definido
        setConfigLimiteNf(empresa.limiteNotasFiscais && empresa.limiteNotasFiscais > 0 ? empresa.limiteNotasFiscais : 100);
        setShowModalConfig(true);
    };

    const handleToggleNfse = (ativa: boolean) => {
        setConfigNfseAtiva(ativa);
        // Ao ligar, se nao houver limite, sugerir 100
        if (ativa && (!configLimiteNf || configLimiteNf <= 0)) setConfigLimiteNf(100);
    };

    const handleConfirmarConfig = async () => {
        if (!empresaParaConfig) return;
        setCarregandoConfig(true);
        try {
            await api.put(`/Empresa/admin/configuracoes/${empresaParaConfig.id}`, {
                limiteDeVeiculos: configLimiteVeiculos,
                emissaoNotaFiscalLiberada: configNfseAtiva,
                limiteNotasFiscais: configNfseAtiva ? configLimiteNf : 0,
            });
            setShowModalConfig(false);
            toast.success("Configurações atualizadas com sucesso!");
            fetchEmpresas(paginationModel.page, paginationModel.pageSize);
        } catch (error: any) {
            const axiosError = error as AxiosError<ApiError>;
            setMessageAlerta(tratarErroApi(axiosError, 'Erro ao salvar configurações: '));
            setShowAlerta(true);
        } finally {
            setCarregandoConfig(false);
        }
    };

    const handleAbrirModalSandbox = async (empresa: EmpresaAdmin) => {
        setEmpresaParaSandbox(empresa);
        setSandboxHabilitado(false);
        setSandboxChave("");
        setSandboxChaveConfigurada(false);
        setMostrarSandboxChave(false);
        setShowModalSandbox(true);
        setCarregandoSandbox(true);
        try {
            const res = await api.get(`/Empresa/admin/asaas-sandbox/${empresa.id}`);
            setSandboxHabilitado(!!res.data.habilitado);
            setSandboxChaveConfigurada(!!res.data.chaveConfigurada);
        } catch {
            toast.error("Erro ao carregar a configuração de sandbox");
        } finally {
            setCarregandoSandbox(false);
        }
    };

    const handleConfirmarSandbox = async () => {
        if (!empresaParaSandbox) return;

        // Ligar exige uma chave nova ou uma já configurada (envia string vazia mantém a atual só se
        // ainda existir). Para simplificar, exigimos a chave preenchida ao ligar quando não há uma salva.
        if (sandboxHabilitado && !sandboxChave.trim() && !sandboxChaveConfigurada) {
            toast.error("Informe a chave de API de homologação para habilitar o sandbox.");
            return;
        }

        setSalvandoSandbox(true);
        try {
            const res = await api.put(`/Empresa/admin/asaas-sandbox/${empresaParaSandbox.id}`, {
                habilitado: sandboxHabilitado,
                chaveApiSandbox: sandboxChave.trim(),
            });
            if (res.data?.avisoWebhook) {
                toast.warning(res.data.avisoWebhook);
            } else {
                toast.success("Configuração de sandbox salva!");
            }
            setShowModalSandbox(false);
        } catch (error: any) {
            const msg = error.response?.data?.errorMessage || error.response?.data?.Mensagem || 'Erro ao salvar a configuração de sandbox';
            toast.error(msg);
        } finally {
            setSalvandoSandbox(false);
        }
    };

    const handleAbrirModalAssistente = async (empresa: EmpresaAdmin) => {
        setEmpresaParaAssistente(empresa);
        setAssistenteNivel(0);
        setAssistenteModelo(3);
        setAssistenteLimiteDia('');
        setCarregandoAssistente(true);
        try {
            const res = await api.get(`/AssistenteWhatsApp/admin/${empresa.id}`);
            setAssistenteNivel(res.data.habilitado ? Number(res.data.nivel ?? 2) : 0);
            setAssistenteModelo(Number(res.data.modelo ?? 3) || 3);
            setAssistenteLimiteDia(res.data.limiteMensagensDia ? String(res.data.limiteMensagensDia) : '');
        } catch {
            toast.error("Erro ao carregar a liberação do assistente no WhatsApp");
        } finally {
            setCarregandoAssistente(false);
        }
    };

    const handleSalvarAssistente = async () => {
        if (!empresaParaAssistente) return;
        setSalvandoAssistente(true);
        try {
            const habilitado = assistenteNivel > 0;
            const limite = parseInt(assistenteLimiteDia, 10);
            await api.put(`/AssistenteWhatsApp/admin/${empresaParaAssistente.id}`, {
                habilitado,
                nivel: habilitado ? assistenteNivel : null,
                modelo: habilitado ? assistenteModelo : null,
                limiteMensagensDia: habilitado && limite > 0 ? limite : null,
            });
            const nomes: Record<number, string> = { 1: 'Básico', 2: 'Intermediário', 3: 'Avançado' };
            const modelos: Record<number, string> = { 1: 'Haiku', 2: 'Sonnet', 3: 'Opus' };
            toast.success(habilitado ? `Assistente no WhatsApp liberado no modo ${nomes[assistenteNivel]} com o modelo ${modelos[assistenteModelo]}.` : "Assistente no WhatsApp desligado.");
            setEmpresaParaAssistente(null);
        } catch (error: any) {
            const msg = error.response?.data?.errorMessage || error.response?.data?.Mensagem || 'Erro ao salvar a liberação do assistente';
            toast.error(msg);
        } finally {
            setSalvandoAssistente(false);
        }
    };

    const handleAtivarLocaSmartCheck = async (empresa: EmpresaAdmin) => {
        if (!window.confirm(`Deseja ativar o LocaSmartCheck para a empresa "${empresa.nome}"?`)) return;

        try {
            toast.info(`Ativando LocaSmartCheck para ${empresa.nome}...`);
            await api.post('/LocaSmartCheck/AtivarPorAdmin', { empresaId: empresa.id });
            toast.success(`LocaSmartCheck ativado para ${empresa.nome}!`);
            fetchEmpresas(paginationModel.page, paginationModel.pageSize);
        } catch (error: any) {
            const msg = error.response?.data?.errorMessage || error.response?.data?.Mensagem || 'Erro ao ativar LocaSmartCheck';
            toast.error(msg);
        }
    };

    const handleConciliarJurosMulta = async (empresa: EmpresaAdmin) => {
        if (!window.confirm(`Conciliar juros/multa das locações ativas de "${empresa.nome}" com o Asaas?\n\nVai varrer as locações integradas, corrigir o controle de juros/multa e re-sincronizar as assinaturas/cobranças no Asaas.`)) return;

        setEmpresaConciliando(empresa);
        setCarregandoConciliar(true);
        setResultadoConciliar(null);
        try {
            const res = await api.post(`/Empresa/admin/conciliar-juros-multa-asaas/${empresa.id}`);
            const dados = res.data || {};
            setResultadoConciliar(dados);

            const sincronizadas = dados.totalAsaasSincronizadas || 0;
            const flags = dados.totalFlagCorrigido || 0;
            if (sincronizadas > 0 || flags > 0) {
                toast.success(`Conciliação concluída: ${sincronizadas} assinatura(s) sincronizada(s), ${flags} flag(s) corrigido(s).`);
            } else {
                toast.info(`Nenhuma correção necessária. ${dados.totalVarridas || 0} locação(ões) verificada(s).`);
            }
        } catch (error: any) {
            const msg = error.response?.data?.errorMessage || error.response?.data?.Mensagem || 'Erro ao conciliar juros/multa com o Asaas';
            toast.error(msg);
            setEmpresaConciliando(null);
        } finally {
            setCarregandoConciliar(false);
        }
    };

    const handleAbrirModalConciliacaoAsaas = (empresa: EmpresaAdmin) => {
        previewConciliacaoCanceladoRef.current = true;
        setEmpresaConciliacaoAsaas(empresa);
        setConciliacaoDataCorte(new Date().toISOString().slice(0, 10));
        setCarregandoPreviewConciliacao(false);
        setProgressoPreviewConciliacao(null);
        setAcoesPreviewConciliacao(null);
        setAcoesSelecaoIds(new Set());
        setShowModalConciliacaoAsaas(true);
    };

    const handlePreviewConciliacaoAsaas = async () => {
        if (!empresaConciliacaoAsaas) return;
        setCarregandoPreviewConciliacao(true);
        setProgressoPreviewConciliacao(null);
        setAcoesPreviewConciliacao(null);
        setAcoesSelecaoIds(new Set());
        previewConciliacaoCanceladoRef.current = false;
        try {
            const inicio = await api.post<{ idAnalise: string }>(
                `/Empresa/admin/conciliacao-asaas/preview/${empresaConciliacaoAsaas.id}`,
                { dataCorte: conciliacaoDataCorte }
            );
            const idAnalise = inicio.data?.idAnalise;
            if (!idAnalise) throw new Error('Analise nao iniciada');

            while (true) {
                await new Promise(resolve => setTimeout(resolve, 2500));
                if (previewConciliacaoCanceladoRef.current) return;

                const res = await api.get<StatusPreviewConciliacaoAsaas>(
                    `/Empresa/admin/conciliacao-asaas/preview-status/${idAnalise}`
                );
                if (previewConciliacaoCanceladoRef.current) return;

                const status = res.data;
                setProgressoPreviewConciliacao({ analisadas: status.locacoesAnalisadas, total: status.totalLocacoes });
                if (!status.concluido) continue;

                if (status.erro) {
                    toast.error(status.erro);
                    return;
                }

                const acoes = status.acoes || [];
                setAcoesPreviewConciliacao(acoes);
                const selecionados = new Set<number>();
                acoes.forEach((a, idx) => { if (a.tipo !== 3) selecionados.add(idx); });
                setAcoesSelecaoIds(selecionados);
                if (acoes.length === 0) toast.info("Nenhuma acao de conciliacao encontrada para o periodo.");
                return;
            }
        } catch (error: any) {
            if (previewConciliacaoCanceladoRef.current) return;
            const msg = error.response?.data?.errorMessage || error.response?.data?.Mensagem || 'Erro ao analisar conciliacao';
            toast.error(msg);
        } finally {
            setCarregandoPreviewConciliacao(false);
            setProgressoPreviewConciliacao(null);
        }
    };

    const handleAplicarConciliacaoAsaas = async () => {
        if (!empresaConciliacaoAsaas || !acoesPreviewConciliacao) return;
        const acoesSelecionadas = acoesPreviewConciliacao.filter((_, idx) => acoesSelecaoIds.has(idx));
        if (acoesSelecionadas.length === 0) { toast.error("Selecione ao menos uma acao para aplicar."); return; }
        setCarregandoAplicarConciliacao(true);
        try {
            const res = await api.post<ResultadoAplicarConciliacaoAsaas[]>(
                `/Empresa/admin/conciliacao-asaas/aplicar/${empresaConciliacaoAsaas.id}`,
                { dataCorte: conciliacaoDataCorte, acoes: acoesSelecionadas }
            );
            const resultados = res.data || [];
            const aplicadas = resultados.filter(r => r.aplicada).length;
            const falhas = resultados.filter(r => !r.aplicada).length;
            if (falhas > 0) {
                toast.warning(`${aplicadas} aplicada(s), ${falhas} com falha.`);
            } else {
                toast.success(`${aplicadas} acao(s) aplicada(s) com sucesso.`);
            }
            setAcoesPreviewConciliacao(null);
            setAcoesSelecaoIds(new Set());
        } catch (error: any) {
            const msg = error.response?.data?.errorMessage || error.response?.data?.Mensagem || 'Erro ao aplicar conciliacao';
            toast.error(msg);
        } finally {
            setCarregandoAplicarConciliacao(false);
        }
    };

    const normalizarSlug = (valor: string) =>
        valor.trim().toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '').slice(0, 40);

    const handleAbrirModalSite = async (empresa: EmpresaAdmin) => {
        setEmpresaParaSite(empresa);
        setSiteExistente(null);
        setSiteSlug(normalizarSlug(empresa.nome || ''));
        setSiteCategoria(1);
        setSlugDisponivel(null);
        setVerificandoSlug(false);
        setEditandoSlug(false);
        setShowModalSite(true);
        setCarregandoSite(true);
        try {
            const res = await api.get(`/SiteEmpresa/admin/${empresa.id}`);
            if (res.data && res.data.slug) {
                setSiteExistente({ slug: res.data.slug, categoria: res.data.categoria, publicado: res.data.publicado });
            }
        } catch {
            toast.error("Erro ao carregar dados do site");
        } finally {
            setCarregandoSite(false);
        }
    };

    useEffect(() => {
        if (!showModalSite || siteExistente) return;
        const slug = siteSlug;
        if (!slug) { setSlugDisponivel(null); return; }
        setVerificandoSlug(true);
        setSlugDisponivel(null);
        const timer = setTimeout(async () => {
            try {
                const res = await api.get(`/SiteEmpresa/admin/slug-disponivel?slug=${encodeURIComponent(slug)}`);
                setSlugDisponivel(!!res.data.disponivel);
            } catch {
                setSlugDisponivel(null);
            } finally {
                setVerificandoSlug(false);
            }
        }, 500);
        return () => clearTimeout(timer);
    }, [siteSlug, showModalSite, siteExistente]);

    useEffect(() => {
        if (!editandoSlug || !siteExistente) return;
        if (!novoSlug || novoSlug === siteExistente.slug) { setNovoSlugDisponivel(null); setVerificandoNovoSlug(false); return; }
        setVerificandoNovoSlug(true);
        setNovoSlugDisponivel(null);
        const timer = setTimeout(async () => {
            try {
                const res = await api.get(`/SiteEmpresa/admin/slug-disponivel?slug=${encodeURIComponent(novoSlug)}`);
                setNovoSlugDisponivel(!!res.data.disponivel);
            } catch {
                setNovoSlugDisponivel(null);
            } finally {
                setVerificandoNovoSlug(false);
            }
        }, 500);
        return () => clearTimeout(timer);
    }, [novoSlug, editandoSlug, siteExistente]);

    const handleSalvarSlug = async () => {
        if (!empresaParaSite || !siteExistente || !novoSlugDisponivel) return;
        setSalvandoSlug(true);
        try {
            const res = await api.put(`/SiteEmpresa/admin/${empresaParaSite.id}/slug`, { slug: novoSlug });
            setSiteExistente({ ...siteExistente, slug: res.data.slug });
            setEditandoSlug(false);
            toast.success("Endereço do site alterado.");
        } catch (error: any) {
            const msg = error.response?.data?.mensagem || error.response?.data?.Mensagem || 'Erro ao alterar o endereço do site';
            toast.error(msg);
        } finally {
            setSalvandoSlug(false);
        }
    };

    const handleGerarSite = async () => {
        if (!empresaParaSite || !slugDisponivel) return;
        setGerandoSite(true);
        try {
            const res = await api.post(`/SiteEmpresa/admin/${empresaParaSite.id}`, { slug: siteSlug, categoria: siteCategoria });
            setSiteExistente({ slug: res.data.slug, categoria: res.data.categoria, publicado: res.data.publicado });
            toast.success("Site gerado com sucesso!");
        } catch (error: any) {
            const msg = error.response?.data?.mensagem || error.response?.data?.Mensagem || 'Erro ao gerar site';
            toast.error(msg);
        } finally {
            setGerandoSite(false);
        }
    };

    const handleRegerarConteudoIa = async () => {
        if (!empresaParaSite || !siteExistente) return;
        setRegerandoConteudo(true);
        try {
            await api.post(`/SiteEmpresa/admin/${empresaParaSite.id}/regerar-conteudo-ia`);
            toast.success("Conteúdo do site regerado com IA.");
        } catch (error: any) {
            const msg = error.response?.data?.mensagem || error.response?.data?.Mensagem || 'Erro ao regerar conteúdo do site';
            toast.error(msg);
        } finally {
            setRegerandoConteudo(false);
        }
    };

    const handleTogglePublicacaoSite = async (publicar: boolean) => {
        if (!empresaParaSite || !siteExistente) return;
        if (!publicar && !await confirm(`Despublicar o site de "${empresaParaSite.nome}"? O site ficará inacessível até ser publicado novamente.`)) return;
        setAlterandoPublicacao(true);
        try {
            await api.put(`/SiteEmpresa/admin/${empresaParaSite.id}/publicacao`, { publicado: publicar });
            setSiteExistente(prev => prev ? { ...prev, publicado: publicar } : null);
            toast.success(publicar ? "Site publicado!" : "Site despublicado!");
        } catch (error: any) {
            const msg = error.response?.data?.mensagem || error.response?.data?.Mensagem || 'Erro ao atualizar publicação';
            toast.error(msg);
        } finally {
            setAlterandoPublicacao(false);
        }
    };

    const acoesExtras = [
        {
            Texto: 'Configurações',
            Icone: FaCog,
            Cor: '#6a1b9a',
            OnClick: (entidade: any) => handleAbrirModalConfig(entidade),
        },
        {
            Texto: 'Editar',
            Icone: FaEdit,
            Cor: '#1565c0',
            OnClick: (entidade: any) => handleAbrirModalEditar(entidade),
        },
        {
            Texto: 'Ativar',
            Icone: FaRocket,
            Cor: '#2e7d32',
            OnClick: (entidade: any) => handleAbrirModalAtivar(entidade),
        },
        {
            Texto: 'LocaSmartTrack',
            Icone: FaSatelliteDish,
            Cor: '#0f766e',
            OnClick: (entidade: any) => handleToggleLocaSmartTrack(entidade),
        },
        {
            Texto: 'Gestão de Risco',
            Icone: MdSecurity,
            Cor: '#1F467E',
            OnClick: (entidade: any) => handleToggleGestaoRisco(entidade),
        },
        {
            Texto: 'Ativar LocaSmartCheck',
            Icone: FaCheckCircle,
            Cor: '#0a1929',
            OnClick: (entidade: any) => handleAtivarLocaSmartCheck(entidade),
            Condicao: (entidade: any) => !entidade.integradoLocaSmartCheck,
        },
        {
            Texto: 'Conciliar Juros/Multa (Asaas)',
            Icone: FaSyncAlt,
            Cor: '#0277bd',
            OnClick: (entidade: any) => handleConciliarJurosMulta(entidade),
        },
        {
            Texto: 'Sandbox Asaas',
            Icone: FaFlask,
            Cor: '#00695c',
            OnClick: (entidade: any) => handleAbrirModalSandbox(entidade),
        },
        {
            Texto: 'Assistente WhatsApp',
            Icone: FaWhatsapp,
            Cor: '#1F467E',
            OnClick: (entidade: any) => handleAbrirModalAssistente(entidade),
        },
        {
            Texto: 'Site da Locadora',
            Icone: MdLanguage,
            Cor: '#1F467E',
            OnClick: (entidade: any) => handleAbrirModalSite(entidade),
        },
        {
            Texto: 'Conciliar Asaas',
            Icone: FaSyncAlt,
            Cor: '#0d47a1',
            OnClick: (entidade: any) => handleAbrirModalConciliacaoAsaas(entidade),
        },
    ];

    if (!isAdmin) {
        return (
            <LocaSmartLayout>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '60vh', color: '#666' }}>
                    <MdBlock size={64} style={{ marginBottom: 16, color: '#ccc' }} />
                    <h2 style={{ margin: 0, fontSize: '1.2rem' }}>Acesso restrito</h2>
                    <p style={{ marginTop: 8, fontSize: '0.9rem' }}>Voce nao tem permissao para acessar esta pagina.</p>
                </div>
            </LocaSmartLayout>
        );
    }

    return (
        <>
            <LocaSmartLayout>
                <Tabs
                    value={aba}
                    onChange={(_, v) => setAba(v)}
                    sx={{ mb: 1, minHeight: 36, '& .MuiTab-root': { minHeight: 36, py: 0.5, textTransform: 'none', fontWeight: 600 } }}
                >
                    <Tab label="Empresas" />
                    <Tab label="Saques Pendentes" />
                    <Tab label="Reconciliação" />
                    <Tab label="Configurações do Sistema" />
                    <Tab label="Consumo do Assistente" />
                </Tabs>

                {aba === 0 && (
                <Listagem
                    colunas={colunas}
                    linhas={empresas}
                    nomeEntidade="Empresas"
                    nomePropriedade="nome"
                    carregando={carregando}
                    IconeEntidade={MdBusiness}
                    exibirAcoesDeCrud={false}
                    acoesExtras={acoesExtras}
                    handleEditar={() => {}}
                    handleCriar={() => {}}
                    handleExclusao={() => {}}
                    handleVisualizacao={() => {}}
                    handleSelecionarEntidade={() => {}}
                    ocultarNovo={true}
                    paginationMode="server"
                    rowCount={rowCount}
                    paginationModel={paginationModel}
                    onPaginationModelChange={setPaginationModel}
                    filtros={configFiltros}
                />
                )}

                {aba === 1 && (<FilaSaques />)}

                {aba === 2 && (<FilaReconciliacao />)}

                {aba === 3 && (<ConfiguracoesSistema />)}

                {aba === 4 && (<ConsumoAssistente />)}

                {/* Modal Ativar Empresa */}
                {showModalAtivar && empresaParaAtivar && (
                    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                        <div className="bg-white rounded-lg shadow-xl p-6 w-full max-w-md mx-4">
                            <h3 className="text-lg font-semibold text-gray-800 mb-4">
                                Ativar Empresa
                            </h3>
                            <p className="text-sm text-gray-600 mb-4">
                                <strong>{empresaParaAtivar.nome}</strong> ({empresaParaAtivar.documento})
                            </p>

                            <div className="space-y-3">
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">Tipo do Plano</label>
                                    <select
                                        className="w-full border border-gray-300 rounded-md p-2 text-sm focus:ring-2 focus:ring-blue-800 focus:border-blue-800"
                                        value={ativarTipoPlano}
                                        onChange={(e) => {
                                            setAtivarTipoPlano(e.target.value);
                                            if (e.target.value === "PRO") setAtivarLimiteVeiculos(5);
                                            else setAtivarLimiteVeiculos(10);
                                        }}
                                    >
                                        <option value="PRO">PRO</option>
                                        <option value="AVANCADO">AVANCADO</option>
                                    </select>
                                </div>

                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">Limite de Veiculos</label>
                                    <input
                                        type="number"
                                        className="w-full border border-gray-300 rounded-md p-2 text-sm focus:ring-2 focus:ring-blue-800 focus:border-blue-800"
                                        value={ativarLimiteVeiculos}
                                        onChange={(e) => setAtivarLimiteVeiculos(Number(e.target.value))}
                                        min={1}
                                    />
                                </div>

                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">Expira Em</label>
                                    <input
                                        type="datetime-local"
                                        className="w-full border border-gray-300 rounded-md p-2 text-sm focus:ring-2 focus:ring-blue-800 focus:border-blue-800"
                                        value={ativarExpiraEm}
                                        onChange={(e) => setAtivarExpiraEm(e.target.value)}
                                    />
                                </div>

                                <div className="flex items-center gap-2 pt-1">
                                    <input
                                        id="ativar-locasmarttrack"
                                        type="checkbox"
                                        checked={ativarLocaSmartTrack}
                                        onChange={(e) => setAtivarLocaSmartTrack(e.target.checked)}
                                    />
                                    <label htmlFor="ativar-locasmarttrack" className="text-sm text-gray-700">
                                        Cliente com LocaSmartTrack
                                    </label>
                                </div>
                            </div>

                            <div className="flex justify-end gap-2 mt-6">
                                <button
                                    className="px-4 py-2 text-sm text-gray-600 border border-gray-300 rounded-md hover:bg-gray-100"
                                    onClick={() => setShowModalAtivar(false)}
                                    disabled={carregandoAtivar}
                                >
                                    Cancelar
                                </button>
                                <button
                                    className="px-4 py-2 text-sm text-white rounded-md hover:opacity-90 disabled:opacity-50"
                                    style={{ backgroundColor: "#1F467E" }}
                                    onClick={handleClickConfirmarAtivar}
                                    disabled={carregandoAtivar || !ativarExpiraEm}
                                >
                                    {carregandoAtivar ? 'Ativando...' : 'Confirmar Ativacao'}
                                </button>
                            </div>
                        </div>
                    </div>
                )}

                {showModalConfirmarTrack && empresaParaAtivar && (
                    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                        <div className="bg-white rounded-lg shadow-xl p-6 w-full max-w-sm mx-4">
                            <h3 className="text-lg font-semibold text-gray-800 mb-2">
                                {ativarLocaSmartTrack
                                    ? 'Realmente deseja ATIVAR o LocaSmartTrack (Rastreamento)?'
                                    : 'Realmente deseja NÃO ATIVAR o LocaSmartTrack (Rastreamento)?'}
                            </h3>
                            <p className="text-sm text-gray-600 mb-6">
                                Empresa: <strong>{empresaParaAtivar.nome}</strong>
                            </p>
                            <div className="flex justify-end gap-2">
                                <button
                                    className="px-4 py-2 text-sm text-gray-600 border border-gray-300 rounded-md hover:bg-gray-100"
                                    onClick={() => setShowModalConfirmarTrack(false)}
                                    disabled={carregandoAtivar}
                                >
                                    Não
                                </button>
                                <button
                                    className="px-4 py-2 text-sm text-white rounded-md hover:opacity-90 disabled:opacity-50"
                                    style={{ backgroundColor: "#1F467E" }}
                                    onClick={() => handleConfirmarAtivar(ativarLocaSmartTrack)}
                                    disabled={carregandoAtivar}
                                >
                                    {carregandoAtivar ? 'Ativando...' : 'Sim'}
                                </button>
                            </div>
                        </div>
                    </div>
                )}

                {/* Modal Editar Empresa */}
                {showModalEditar && empresaParaEditar && (
                    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                        <div className="bg-white rounded-lg shadow-xl p-6 w-full max-w-md mx-4">
                            <h3 className="text-lg font-semibold text-gray-800 mb-4">
                                Editar Empresa
                            </h3>

                            <div className="space-y-3">
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">Razão Social / Nome</label>
                                    <input
                                        type="text"
                                        className="w-full border border-gray-300 rounded-md p-2 text-sm focus:ring-2 focus:ring-blue-800 focus:border-blue-800"
                                        value={editarNome}
                                        onChange={(e) => setEditarNome(e.target.value)}
                                    />
                                </div>

                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">Documento (CNPJ/CPF)</label>
                                    <input
                                        type="text"
                                        className="w-full border border-gray-300 rounded-md p-2 text-sm focus:ring-2 focus:ring-blue-800 focus:border-blue-800"
                                        value={editarDocumento}
                                        onChange={(e) => setEditarDocumento(e.target.value)}
                                    />
                                </div>

                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">Usuários</label>
                                    <p className="text-xs text-gray-500 mb-2">As alterações de cada usuário são salvas individualmente nos botões de cada linha.</p>
                                    {carregandoUsuarios ? (
                                        <p className="text-sm text-gray-500">Carregando...</p>
                                    ) : editarUsuarios.length === 0 ? (
                                        <p className="text-sm text-gray-500">Nenhum usuário encontrado</p>
                                    ) : (
                                        <div className="space-y-2 max-h-48 overflow-y-auto">
                                            {editarUsuarios.map(u => (
                                                <div key={u.id} className="border border-gray-200 rounded-md p-2 space-y-1.5">
                                                    <div className="flex items-center gap-1">
                                                        {u.administrador && (
                                                            <span className="text-[10px] bg-blue-100 text-blue-700 px-1.5 py-0.5 rounded font-semibold">Admin</span>
                                                        )}
                                                    </div>
                                                    <input
                                                        type="text"
                                                        placeholder="Nome"
                                                        className="w-full border border-gray-300 rounded-md p-1.5 text-sm focus:ring-2 focus:ring-blue-800 focus:border-blue-800"
                                                        value={u.nome}
                                                        onChange={(e) => handleNomeUsuarioChange(u.id, e.target.value)}
                                                    />
                                                    <input
                                                        type="email"
                                                        placeholder="E-mail"
                                                        className="w-full border border-gray-300 rounded-md p-1.5 text-sm focus:ring-2 focus:ring-blue-800 focus:border-blue-800"
                                                        value={u.email}
                                                        onChange={(e) => handleEmailUsuarioChange(u.id, e.target.value)}
                                                    />
                                                    <div className="flex items-center gap-1">
                                                        <input
                                                            type={senhasReveladas[u.id] ? 'text' : 'password'}
                                                            readOnly
                                                            className="flex-1 border border-gray-200 rounded-md p-1.5 text-sm bg-gray-50"
                                                            value={u.senha || ''}
                                                        />
                                                        <button type="button"
                                                            className="px-2 py-1 text-xs border border-gray-300 rounded-md hover:bg-gray-100"
                                                            onClick={() => setSenhasReveladas(prev => ({ ...prev, [u.id]: !prev[u.id] }))}>
                                                            {senhasReveladas[u.id] ? 'Ocultar' : 'Ver'}
                                                        </button>
                                                    </div>
                                                    <div className="flex items-center gap-1">
                                                        <input
                                                            type="text"
                                                            placeholder="Nova senha"
                                                            className="flex-1 border border-gray-300 rounded-md p-1.5 text-sm focus:ring-2 focus:ring-blue-800 focus:border-blue-800"
                                                            value={novasSenhas[u.id] || ''}
                                                            onChange={(e) => setNovasSenhas(prev => ({ ...prev, [u.id]: e.target.value }))}
                                                        />
                                                        <button type="button"
                                                            className="px-2 py-1 text-xs text-white rounded-md disabled:opacity-50"
                                                            style={{ backgroundColor: "#6a1b9a" }}
                                                            disabled={salvandoUsuarioId === u.id}
                                                            onClick={() => handleDefinirSenha(u.id)}>
                                                            Definir senha
                                                        </button>
                                                    </div>
                                                    <button type="button"
                                                        className="w-full px-2 py-1 text-xs text-white rounded-md disabled:opacity-50"
                                                        style={{ backgroundColor: "#1565c0" }}
                                                        disabled={salvandoUsuarioId === u.id}
                                                        onClick={() => handleSalvarUsuario(u)}>
                                                        {salvandoUsuarioId === u.id ? 'Salvando...' : 'Salvar nome/e-mail'}
                                                    </button>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            </div>

                            <div className="flex justify-end gap-2 mt-6">
                                <button
                                    className="px-4 py-2 text-sm text-gray-600 border border-gray-300 rounded-md hover:bg-gray-100"
                                    onClick={() => setShowModalEditar(false)}
                                    disabled={carregandoEditar}
                                >
                                    Cancelar
                                </button>
                                <button
                                    className="px-4 py-2 text-sm text-white rounded-md hover:opacity-90 disabled:opacity-50"
                                    style={{ backgroundColor: "#1F467E" }}
                                    onClick={handleConfirmarEditar}
                                    disabled={carregandoEditar}
                                >
                                    {carregandoEditar ? 'Salvando...' : 'Salvar dados da empresa'}
                                </button>
                            </div>
                        </div>
                    </div>
                )}

                {/* Modal Configurações */}
                {showModalConfig && empresaParaConfig && (
                    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                        <div className="bg-white rounded-lg shadow-xl p-6 w-full max-w-md mx-4">
                            <h3 className="text-lg font-semibold text-gray-800 mb-4">Configurações da Empresa</h3>
                            <p className="text-sm text-gray-600 mb-4"><strong>{empresaParaConfig.nome}</strong></p>

                            <div className="space-y-3">
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">Limite de Veículos</label>
                                    <input type="number" min={0}
                                        className="w-full border border-gray-300 rounded-md p-2 text-sm focus:ring-2 focus:ring-blue-800 focus:border-blue-800"
                                        value={configLimiteVeiculos}
                                        onChange={(e) => setConfigLimiteVeiculos(Number(e.target.value))} />
                                </div>

                                <div className="flex items-center gap-2">
                                    <input id="nfseAtiva" type="checkbox"
                                        checked={configNfseAtiva}
                                        onChange={(e) => handleToggleNfse(e.target.checked)} />
                                    <label htmlFor="nfseAtiva" className="text-sm font-medium text-gray-700">Ativar módulo de NFSe</label>
                                </div>

                                {configNfseAtiva && (
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">Limite de NF por mês (0 = ilimitado)</label>
                                        <input type="number" min={0}
                                            className="w-full border border-gray-300 rounded-md p-2 text-sm focus:ring-2 focus:ring-blue-800 focus:border-blue-800"
                                            value={configLimiteNf}
                                            onChange={(e) => setConfigLimiteNf(Number(e.target.value))} />
                                        <p className="text-xs text-gray-500 mt-1">Sugestão: 100</p>
                                    </div>
                                )}
                            </div>

                            <div className="flex justify-end gap-2 mt-6">
                                <button className="px-4 py-2 text-sm text-gray-600 border border-gray-300 rounded-md hover:bg-gray-100"
                                    onClick={() => setShowModalConfig(false)} disabled={carregandoConfig}>Cancelar</button>
                                <button className="px-4 py-2 text-sm text-white rounded-md hover:opacity-90 disabled:opacity-50"
                                    style={{ backgroundColor: "#1F467E" }}
                                    onClick={handleConfirmarConfig} disabled={carregandoConfig}>
                                    {carregandoConfig ? 'Salvando...' : 'Salvar'}
                                </button>
                            </div>
                        </div>
                    </div>
                )}

                {/* Modal Sandbox Asaas */}
                {showModalSandbox && empresaParaSandbox && (
                    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                        <div className="bg-white rounded-lg shadow-xl p-6 w-full max-w-md mx-4">
                            <h3 className="text-lg font-semibold text-gray-800 mb-1">Ambiente de testes (Sandbox Asaas)</h3>
                            <p className="text-sm text-gray-600 mb-4"><strong>{empresaParaSandbox.nome}</strong></p>

                            {carregandoSandbox ? (
                                <p className="text-sm text-gray-500 py-6 text-center">Carregando...</p>
                            ) : (
                                <>
                                    <div
                                        style={{ display: 'flex', gap: 8, alignItems: 'flex-start', background: '#eaf1fb', border: '1px solid #c5d8f2', borderRadius: 6, padding: '10px 12px', marginBottom: 16 }}
                                    >
                                        <MdInfoOutline size={20} color="#1F467E" style={{ flexShrink: 0, marginTop: 1 }} />
                                        <span style={{ fontSize: '0.82rem', color: '#1F467E' }}>
                                            Com o sandbox ligado, as cobranças de locação desta empresa passam a ir para o
                                            ambiente de testes do Asaas, usando a chave de homologação. Use apenas em empresas
                                            de teste, não em clientes reais.
                                        </span>
                                    </div>

                                    <div className="flex items-center gap-2 mb-3">
                                        <input id="sandboxHabilitado" type="checkbox"
                                            checked={sandboxHabilitado}
                                            onChange={(e) => setSandboxHabilitado(e.target.checked)} />
                                        <label htmlFor="sandboxHabilitado" className="text-sm font-medium text-gray-700">
                                            Habilitar ambiente de testes (Sandbox Asaas)
                                        </label>
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">
                                            Chave de API de homologação
                                        </label>
                                        <div className="flex items-center gap-1">
                                            <input
                                                type={mostrarSandboxChave ? 'text' : 'password'}
                                                className="flex-1 border border-gray-300 rounded-md p-2 text-sm focus:ring-2 focus:ring-blue-800 focus:border-blue-800"
                                                placeholder={sandboxChaveConfigurada ? 'Chave configurada, informe para substituir' : '$aact_hmlg_...'}
                                                value={sandboxChave}
                                                onChange={(e) => setSandboxChave(e.target.value)}
                                            />
                                            <button type="button"
                                                className="px-2 py-2 text-xs border border-gray-300 rounded-md hover:bg-gray-100"
                                                onClick={() => setMostrarSandboxChave(v => !v)}>
                                                {mostrarSandboxChave ? 'Ocultar' : 'Ver'}
                                            </button>
                                        </div>
                                        {sandboxChaveConfigurada && (
                                            <p className="text-xs text-gray-500 mt-1">
                                                Já existe uma chave salva. Deixe em branco para manter a atual.
                                            </p>
                                        )}
                                    </div>
                                </>
                            )}

                            <div className="flex justify-end gap-2 mt-6">
                                <button className="px-4 py-2 text-sm text-gray-600 border border-gray-300 rounded-md hover:bg-gray-100"
                                    onClick={() => setShowModalSandbox(false)} disabled={salvandoSandbox}>Cancelar</button>
                                <button className="px-4 py-2 text-sm text-white rounded-md hover:opacity-90 disabled:opacity-50"
                                    style={{ backgroundColor: "#1F467E" }}
                                    onClick={handleConfirmarSandbox} disabled={carregandoSandbox || salvandoSandbox}>
                                    {salvandoSandbox ? 'Salvando...' : 'Salvar'}
                                </button>
                            </div>
                        </div>
                    </div>
                )}

                {empresaParaAssistente && (
                    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                        <div className="bg-white rounded-lg shadow-xl p-6 w-full max-w-md mx-4">
                            <h3 className="text-lg font-semibold text-gray-800 mb-1">Assistente no WhatsApp</h3>
                            <p className="text-sm text-gray-600 mb-4"><strong>{empresaParaAssistente.nome}</strong></p>

                            {carregandoAssistente ? (
                                <p className="text-sm text-gray-500 py-6 text-center">Carregando...</p>
                            ) : (
                                <>
                                    <div
                                        style={{ display: 'flex', gap: 8, alignItems: 'flex-start', background: '#eaf1fb', border: '1px solid #c5d8f2', borderRadius: 6, padding: '10px 12px', marginBottom: 16 }}
                                    >
                                        <MdInfoOutline size={20} color="#1F467E" style={{ flexShrink: 0, marginTop: 1 }} />
                                        <span style={{ fontSize: '0.82rem', color: '#1F467E' }}>
                                            Com o recurso liberado, os usuários desta empresa podem cadastrar o celular em Minha Conta
                                            e fazer perguntas sobre a locadora pelo WhatsApp. Cada resposta usa IA.
                                        </span>
                                    </div>

                                    <label htmlFor="assistenteNivel" className="block text-sm font-medium text-gray-700 mb-1">
                                        Modo do assistente
                                    </label>
                                    <select id="assistenteNivel"
                                        className="w-full p-2 border border-gray-300 rounded-md bg-white text-sm"
                                        value={assistenteNivel}
                                        onChange={(e) => setAssistenteNivel(Number(e.target.value))}>
                                        <option value={0}>Desligado</option>
                                        <option value={1}>Básico: só consultas</option>
                                        <option value={2}>Intermediário: consultas e ações com confirmação</option>
                                        <option value={3}>Avançado: tudo, mais fotos, PDFs, áudios e instruções próprias</option>
                                    </select>
                                    <p className="text-xs text-gray-500 mt-2">
                                        {assistenteNivel === 0 && 'Ninguém da empresa consegue usar o assistente pelo WhatsApp.'}
                                        {assistenteNivel === 1 && 'O assistente responde perguntas sobre a locadora. Não cadastra, não altera, não lê arquivos.'}
                                        {assistenteNivel === 2 && 'Além das consultas, cadastra, altera, inativa e dá baixa, sempre com a confirmação do usuário.'}
                                        {assistenteNivel === 3 && 'Lê fotos, PDFs e áudios, e a empresa pode guardar até 20 instruções próprias para o assistente seguir.'}
                                    </p>

                                    {assistenteNivel > 0 && (
                                        <>
                                            <label htmlFor="assistenteModelo" className="block text-sm font-medium text-gray-700 mb-1 mt-4">
                                                Modelo de IA
                                            </label>
                                            <select id="assistenteModelo"
                                                className="w-full p-2 border border-gray-300 rounded-md bg-white text-sm"
                                                value={assistenteModelo}
                                                onChange={(e) => setAssistenteModelo(Number(e.target.value))}>
                                                <option value={1}>Haiku: o mais barato, para consultas simples</option>
                                                <option value={2}>Sonnet: equilíbrio entre custo e qualidade</option>
                                                <option value={3}>Opus: o mais capaz, para lotes, SQL livre e leitura de arquivos</option>
                                            </select>
                                            <p className="text-xs text-gray-500 mt-2">
                                                {assistenteModelo === 1 && 'Custa cerca de 40 vezes menos que o Opus. Pode errar em pedidos complexos ou em consultas livres aos dados.'}
                                                {assistenteModelo === 2 && 'Custa metade do Opus. Bom para consultas e ações do dia a dia.'}
                                                {assistenteModelo === 3 && 'O modelo padrão até aqui. Todos os modelos usam cache de prompt.'}
                                            </p>

                                            <label htmlFor="assistenteLimiteDia" className="block text-sm font-medium text-gray-700 mb-1 mt-4">
                                                Limite de mensagens por dia
                                            </label>
                                            <input id="assistenteLimiteDia"
                                                type="number"
                                                min={1}
                                                step={1}
                                                placeholder="Sem limite"
                                                className="w-full p-2 border border-gray-300 rounded-md bg-white text-sm"
                                                value={assistenteLimiteDia}
                                                onChange={(e) => setAssistenteLimiteDia(e.target.value.replace(/\D/g, ''))} />
                                            <p className="text-xs text-gray-500 mt-2">
                                                Soma de todos os usuários da empresa, no horário de Brasília. Vazio não limita. Ao chegar no limite, o assistente avisa e volta a responder no dia seguinte.
                                            </p>
                                        </>
                                    )}
                                </>
                            )}

                            <div className="flex justify-end gap-2 mt-6">
                                <button className="px-4 py-2 text-sm text-gray-600 border border-gray-300 rounded-md hover:bg-gray-100"
                                    onClick={() => setEmpresaParaAssistente(null)} disabled={salvandoAssistente}>Cancelar</button>
                                <button className="px-4 py-2 text-sm text-white rounded-md hover:opacity-90 disabled:opacity-50"
                                    style={{ backgroundColor: "#1F467E" }}
                                    onClick={handleSalvarAssistente} disabled={carregandoAssistente || salvandoAssistente}>
                                    {salvandoAssistente ? 'Salvando...' : 'Salvar'}
                                </button>
                            </div>
                        </div>
                    </div>
                )}

                {/* Modal Site da Locadora */}
                {showModalSite && empresaParaSite && (
                    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                        <div className="bg-white rounded-lg shadow-xl p-6 w-full max-w-md mx-4">
                            <h3 className="text-lg font-semibold text-gray-800 mb-1">Site da Locadora</h3>
                            <p className="text-sm text-gray-600 mb-4"><strong>{empresaParaSite.nome}</strong> ({empresaParaSite.documento})</p>

                            {carregandoSite ? (
                                <p className="text-sm text-gray-500 py-6 text-center">Carregando...</p>
                            ) : siteExistente ? (
                                <>
                                    <div className="space-y-3 mb-4">
                                        {editandoSlug ? (
                                            <div>
                                                <span className="text-sm font-medium text-gray-700 block mb-1">Novo endereço</span>
                                                <input
                                                    type="text"
                                                    className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm font-mono"
                                                    value={novoSlug}
                                                    onChange={e => setNovoSlug(normalizarSlug(e.target.value))}
                                                    autoFocus
                                                />
                                                <p className="text-xs text-gray-500 mt-1 font-mono break-all">{`https://${novoSlug || '...'}.locasmartpro.com.br`}</p>
                                                {novoSlug && novoSlug !== siteExistente.slug && (
                                                    <p className="text-xs mt-1 flex items-center gap-1" style={{ color: verificandoNovoSlug ? '#777' : novoSlugDisponivel ? '#2e7d32' : '#c62828' }}>
                                                        {verificandoNovoSlug
                                                            ? 'Verificando disponibilidade...'
                                                            : novoSlugDisponivel
                                                                ? <><MdCheckCircle size={14} /> Disponível</>
                                                                : <><MdErrorOutline size={14} /> Indisponível (já em uso, reservado ou formato inválido)</>}
                                                    </p>
                                                )}
                                                <p className="text-xs text-amber-700 mt-2 flex items-start gap-1">
                                                    <MdInfoOutline size={14} className="mt-0.5 flex-shrink-0" />
                                                    O endereço antigo deixa de funcionar na hora. Quem tiver o link antigo vai cair numa página não encontrada.
                                                </p>
                                                <div className="flex justify-end gap-2 mt-3">
                                                    <button type="button"
                                                        className="px-3 py-1.5 text-sm border border-gray-300 rounded-md hover:bg-gray-100"
                                                        onClick={() => setEditandoSlug(false)}
                                                        disabled={salvandoSlug}>
                                                        Cancelar
                                                    </button>
                                                    <button type="button"
                                                        className="px-3 py-1.5 text-sm rounded-md text-white disabled:opacity-50"
                                                        style={{ backgroundColor: '#1F467E' }}
                                                        onClick={handleSalvarSlug}
                                                        disabled={salvandoSlug || verificandoNovoSlug || !novoSlugDisponivel}>
                                                        {salvandoSlug ? 'Salvando...' : 'Salvar endereço'}
                                                    </button>
                                                </div>
                                            </div>
                                        ) : (
                                            <div className="flex items-center gap-2">
                                                <span className="text-sm font-medium text-gray-700 w-24">Slug</span>
                                                <span className="text-sm text-gray-800 font-mono">{siteExistente.slug}</span>
                                                <button type="button"
                                                    className="p-1 border border-gray-300 rounded-md hover:bg-gray-100"
                                                    title="Editar endereço do site"
                                                    onClick={() => { setNovoSlug(siteExistente.slug); setNovoSlugDisponivel(null); setEditandoSlug(true); }}>
                                                    <MdEdit size={14} color="#555" />
                                                </button>
                                            </div>
                                        )}
                                        <div className="flex items-center gap-2">
                                            <span className="text-sm font-medium text-gray-700 w-24">Categoria</span>
                                            <span className="text-sm text-gray-800">
                                                {siteExistente.categoria === 1 ? 'Rent a Car' : 'Locadora para Motorista de APP'}
                                            </span>
                                        </div>
                                        <div className="flex items-center gap-2">
                                            <span className="text-sm font-medium text-gray-700 w-24">Status</span>
                                            <span style={{
                                                backgroundColor: siteExistente.publicado ? '#c8e6c9' : '#eeeeee',
                                                color: siteExistente.publicado ? '#2e7d32' : '#777',
                                                padding: '2px 10px', borderRadius: 12, fontSize: '0.75rem', fontWeight: 600
                                            }}>
                                                {siteExistente.publicado ? 'Publicado' : 'Rascunho'}
                                            </span>
                                        </div>
                                        <div>
                                            <span className="text-sm font-medium text-gray-700 block mb-1">Endereço</span>
                                            <div className="flex items-center gap-1">
                                                <span className="text-sm text-blue-700 flex-1 break-all font-mono">
                                                    {`https://${siteExistente.slug}.locasmartpro.com.br`}
                                                </span>
                                                <button type="button"
                                                    className="p-1.5 border border-gray-300 rounded-md hover:bg-gray-100"
                                                    title="Copiar link"
                                                    onClick={() => {
                                                        navigator.clipboard.writeText(`https://${siteExistente!.slug}.locasmartpro.com.br`);
                                                        toast.success("Link copiado!");
                                                    }}>
                                                    <MdContentCopy size={16} color="#555" />
                                                </button>
                                                <a href={`https://${siteExistente.slug}.locasmartpro.com.br`} target="_blank" rel="noreferrer"
                                                    className="p-1.5 border border-gray-300 rounded-md hover:bg-gray-100 inline-flex items-center">
                                                    <MdOpenInNew size={16} color="#555" />
                                                </a>
                                            </div>
                                        </div>
                                    </div>

                                    <div
                                        style={{ display: 'flex', gap: 8, alignItems: 'flex-start', background: '#eaf1fb', border: '1px solid #c5d8f2', borderRadius: 6, padding: '10px 12px', marginBottom: 16 }}
                                    >
                                        <MdInfoOutline size={20} color="#1F467E" style={{ flexShrink: 0, marginTop: 1 }} />
                                        <span style={{ fontSize: '0.82rem', color: '#1F467E' }}>
                                            A personalização de textos, cores e veículos é feita pela locadora no menu Meu Site.
                                        </span>
                                    </div>

                                    <div className="mb-4">
                                        <button
                                            className="w-full px-4 py-2 text-sm text-white rounded-md hover:opacity-90 disabled:opacity-50"
                                            style={{ backgroundColor: "#1F467E" }}
                                            onClick={handleRegerarConteudoIa}
                                            disabled={regerandoConteudo}
                                        >
                                            {regerandoConteudo ? 'Regerando conteúdo...' : 'Regerar conteúdo com IA'}
                                        </button>
                                        <p className="text-xs text-gray-500 mt-1">
                                            A regeração substitui os textos gerados (títulos, sobre e FAQ) e mantém cores, fotos e depoimentos.
                                        </p>
                                    </div>

                                    <div className="flex justify-between items-center mt-2">
                                        <button
                                            className="px-4 py-2 text-sm text-white rounded-md hover:opacity-90 disabled:opacity-50"
                                            style={{ backgroundColor: siteExistente.publicado ? '#c62828' : '#2e7d32' }}
                                            onClick={() => handleTogglePublicacaoSite(!siteExistente.publicado)}
                                            disabled={alterandoPublicacao}
                                        >
                                            {alterandoPublicacao ? 'Aguarde...' : siteExistente.publicado ? 'Despublicar' : 'Publicar'}
                                        </button>
                                        <button className="px-4 py-2 text-sm text-gray-600 border border-gray-300 rounded-md hover:bg-gray-100"
                                            onClick={() => setShowModalSite(false)}>
                                            Fechar
                                        </button>
                                    </div>
                                </>
                            ) : (
                                <>
                                    <div className="space-y-3 mb-4">
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">Categoria</label>
                                            <select
                                                className="w-full border border-gray-300 rounded-md p-2 text-sm focus:ring-2 focus:ring-blue-800 focus:border-blue-800"
                                                value={siteCategoria}
                                                onChange={(e) => setSiteCategoria(Number(e.target.value))}
                                            >
                                                <option value={1}>Rent a Car</option>
                                                <option value={2}>Locadora para Motorista de APP</option>
                                            </select>
                                        </div>

                                        <div>
                                            <label className="block text-sm font-medium text-gray-700 mb-1">Slug</label>
                                            <div className="flex items-center gap-2">
                                                <input
                                                    type="text"
                                                    className="flex-1 border border-gray-300 rounded-md p-2 text-sm focus:ring-2 focus:ring-blue-800 focus:border-blue-800 font-mono"
                                                    value={siteSlug}
                                                    onChange={(e) => { setSiteSlug(normalizarSlug(e.target.value)); setSlugDisponivel(null); }}
                                                />
                                                {verificandoSlug && (
                                                    <span className="text-xs text-gray-500 whitespace-nowrap">Verificando...</span>
                                                )}
                                                {!verificandoSlug && slugDisponivel === true && (
                                                    <MdCheckCircle size={20} color="#2e7d32" title="Disponível" />
                                                )}
                                                {!verificandoSlug && slugDisponivel === false && (
                                                    <MdErrorOutline size={20} color="#c62828" title="Indisponível" />
                                                )}
                                            </div>
                                            {!verificandoSlug && slugDisponivel === false && (
                                                <p className="text-xs text-red-600 mt-1">Slug indisponível, escolha outro.</p>
                                            )}
                                            {!verificandoSlug && slugDisponivel === true && (
                                                <p className="text-xs text-green-700 mt-1">Disponível.</p>
                                            )}
                                        </div>

                                        {siteSlug && (
                                            <div>
                                                <span className="text-xs text-gray-500">Preview: </span>
                                                <span className="text-xs text-blue-700 font-mono">{`https://${siteSlug}.locasmartpro.com.br`}</span>
                                            </div>
                                        )}
                                    </div>

                                    <div className="flex justify-end gap-2 mt-6">
                                        <button className="px-4 py-2 text-sm text-gray-600 border border-gray-300 rounded-md hover:bg-gray-100"
                                            onClick={() => setShowModalSite(false)} disabled={gerandoSite}>
                                            Cancelar
                                        </button>
                                        <button
                                            className="px-4 py-2 text-sm text-white rounded-md hover:opacity-90 disabled:opacity-50"
                                            style={{ backgroundColor: "#1F467E" }}
                                            onClick={handleGerarSite}
                                            disabled={!slugDisponivel || gerandoSite || !siteSlug}
                                        >
                                            {gerandoSite ? 'Gerando...' : 'Gerar site'}
                                        </button>
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                )}

                {(carregandoConciliar || resultadoConciliar) && empresaConciliando && (
                    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                        <div className="bg-white rounded-lg shadow-xl p-6 w-full max-w-2xl mx-4">
                            <h3 className="text-lg font-semibold text-gray-800 mb-1">
                                Conciliação de Juros/Multa (Asaas)
                            </h3>
                            <p className="text-sm text-gray-600 mb-4">
                                <strong>{empresaConciliando.nome}</strong>
                            </p>

                            {carregandoConciliar ? (
                                <p className="text-sm text-gray-600 py-6 text-center">Conciliando com o Asaas...</p>
                            ) : (
                                <>
                                    <div className="flex gap-8 mb-4">
                                        <div>
                                            <div className="text-2xl font-bold text-gray-800">{resultadoConciliar?.totalVarridas ?? 0}</div>
                                            <div className="text-xs text-gray-500">Locações verificadas</div>
                                        </div>
                                        <div>
                                            <div className="text-2xl font-bold text-green-700">{resultadoConciliar?.totalAsaasSincronizadas ?? 0}</div>
                                            <div className="text-xs text-gray-500">Sincronizadas no Asaas</div>
                                        </div>
                                        <div>
                                            <div className="text-2xl font-bold text-blue-700">{resultadoConciliar?.totalFlagCorrigido ?? 0}</div>
                                            <div className="text-xs text-gray-500">Flags corrigidos</div>
                                        </div>
                                    </div>

                                    {(resultadoConciliar?.detalhes?.length ?? 0) > 0 ? (
                                        <div className="max-h-64 overflow-y-auto border border-gray-200 rounded">
                                            <table className="w-full text-sm">
                                                <thead className="bg-gray-50">
                                                    <tr>
                                                        <th className="text-left p-2">Veículo</th>
                                                        <th className="text-left p-2">Juros/multa no Asaas</th>
                                                        <th className="text-left p-2">Flag</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {resultadoConciliar?.detalhes.map((d: ConciliarJurosMultaItem, i: number) => (
                                                        <tr key={d.idLocacao || i} className="border-t border-gray-100">
                                                            <td className="p-2">{d.placa || d.idLocacao}</td>
                                                            <td className="p-2">{d.asaasSincronizado ? <span className="text-green-700">Sincronizado</span> : '—'}</td>
                                                            <td className="p-2">
                                                                {d.flagAnterior !== d.flagNovo
                                                                    ? <span className="text-blue-700">{d.flagAnterior ? 'Asaas' : 'Sistema'} → {d.flagNovo ? 'Asaas' : 'Sistema'}</span>
                                                                    : '—'}
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    ) : (
                                        <p className="text-sm text-gray-500">Nenhuma locação precisou de ajuste.</p>
                                    )}

                                    {(resultadoConciliar?.falhas?.length ?? 0) > 0 && (
                                        <div className="mt-3">
                                            <div className="text-sm font-semibold text-red-600 mb-1">Falhas ao atualizar no Asaas</div>
                                            <ul className="text-xs text-red-600 list-disc pl-5">
                                                {resultadoConciliar?.falhas.map((f: string, i: number) => (
                                                    <li key={i}>{f}</li>
                                                ))}
                                            </ul>
                                        </div>
                                    )}
                                </>
                            )}

                            <div className="flex justify-end gap-2 mt-6">
                                <button
                                    className="px-4 py-2 text-sm text-white bg-blue-800 rounded-md hover:bg-blue-900 disabled:opacity-60"
                                    onClick={() => { setEmpresaConciliando(null); setResultadoConciliar(null); }}
                                    disabled={carregandoConciliar}
                                >
                                    Fechar
                                </button>
                            </div>
                        </div>
                    </div>
                )}

                {/* Modal Conciliacao Asaas por empresa */}
                {showModalConciliacaoAsaas && empresaConciliacaoAsaas && (
                    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                        <div className="bg-white rounded-lg shadow-xl p-6 w-full mx-4" style={{ maxWidth: 860 }}>
                            <h3 className="text-lg font-semibold text-gray-800 mb-1">
                                Conciliacao Asaas
                            </h3>
                            <p className="text-sm text-gray-600 mb-4">
                                <strong>{empresaConciliacaoAsaas.nome}</strong>
                            </p>

                            <div className="flex items-end gap-3 mb-4">
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">Data de corte</label>
                                    <input
                                        type="date"
                                        className="border border-gray-300 rounded-md p-2 text-sm focus:ring-2 focus:ring-blue-800 focus:border-blue-800"
                                        value={conciliacaoDataCorte}
                                        onChange={(e) => { setConciliacaoDataCorte(e.target.value); setAcoesPreviewConciliacao(null); setAcoesSelecaoIds(new Set()); }}
                                    />
                                </div>
                                <button
                                    className="px-4 py-2 text-sm text-white rounded-md hover:opacity-90 disabled:opacity-50"
                                    style={{ backgroundColor: '#1F467E' }}
                                    onClick={handlePreviewConciliacaoAsaas}
                                    disabled={carregandoPreviewConciliacao || !conciliacaoDataCorte}
                                >
                                    {carregandoPreviewConciliacao ? 'Analisando...' : 'Analisar'}
                                </button>
                            </div>

                            {carregandoPreviewConciliacao && (
                                <div className="mb-4">
                                    <div style={{ fontSize: '0.8rem', color: '#555', marginBottom: 6 }}>
                                        {progressoPreviewConciliacao && progressoPreviewConciliacao.total > 0
                                            ? `Analisando locacoes no Asaas: ${progressoPreviewConciliacao.analisadas} de ${progressoPreviewConciliacao.total}`
                                            : 'Iniciando analise...'}
                                    </div>
                                    <div style={{ height: 8, background: '#e0e0e0', borderRadius: 4, overflow: 'hidden' }}>
                                        <div style={{
                                            height: '100%',
                                            background: '#1F467E',
                                            transition: 'width 0.4s',
                                            width: `${progressoPreviewConciliacao && progressoPreviewConciliacao.total > 0
                                                ? Math.round((progressoPreviewConciliacao.analisadas / progressoPreviewConciliacao.total) * 100)
                                                : 0}%`
                                        }} />
                                    </div>
                                </div>
                            )}

                            {acoesPreviewConciliacao !== null && (
                                <>
                                    {acoesPreviewConciliacao.length === 0 ? (
                                        <p className="text-sm text-gray-500 mb-4">Nenhuma acao de conciliacao encontrada para o periodo.</p>
                                    ) : (
                                        <>
                                            <div className="flex gap-6 mb-4">
                                                {[0, 1, 2, 3].map(tipo => {
                                                    const qtd = acoesPreviewConciliacao.filter(a => a.tipo === tipo).length;
                                                    if (qtd === 0) return null;
                                                    const cores: Record<number, { bg: string; color: string }> = {
                                                        0: { bg: '#e3f2fd', color: '#1565c0' },
                                                        1: { bg: '#e8f5e9', color: '#2e7d32' },
                                                        2: { bg: '#fff3e0', color: '#e65100' },
                                                        3: { bg: '#fce4ec', color: '#b71c1c' },
                                                    };
                                                    const c = cores[tipo];
                                                    return (
                                                        <div key={tipo} style={{ background: c.bg, borderRadius: 8, padding: '8px 16px', minWidth: 120 }}>
                                                            <div style={{ fontSize: '1.4rem', fontWeight: 700, color: c.color }}>{qtd}</div>
                                                            <div style={{ fontSize: '0.75rem', color: c.color }}>{ROTULOS_ACAO_CONCILIACAO[tipo]}</div>
                                                        </div>
                                                    );
                                                })}
                                                <div style={{ background: '#f5f5f5', borderRadius: 8, padding: '8px 16px', minWidth: 140 }}>
                                                    <div style={{ fontSize: '1.4rem', fontWeight: 700, color: '#333' }}>
                                                        {acoesPreviewConciliacao
                                                            .filter(a => a.tipo !== 3)
                                                            .reduce((s, a) => s + (a.valor || 0), 0)
                                                            .toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                                                    </div>
                                                    <div style={{ fontSize: '0.75rem', color: '#555' }}>Valor total aplicavel</div>
                                                </div>
                                            </div>

                                            <div style={{ maxHeight: 340, overflowY: 'auto', border: '1px solid #e0e0e0', borderRadius: 6, marginBottom: 16 }}>
                                                <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.82rem' }}>
                                                    <thead style={{ background: '#f5f5f5', position: 'sticky', top: 0 }}>
                                                        <tr>
                                                            <th style={{ padding: '8px 10px', textAlign: 'center', borderBottom: '1px solid #e0e0e0', width: 40 }}>
                                                                <input
                                                                    type="checkbox"
                                                                    title="Selecionar todos aplicaveis"
                                                                    checked={acoesPreviewConciliacao.filter(a => a.tipo !== 3).every((_, idx) => {
                                                                        const realIdx = acoesPreviewConciliacao.indexOf(acoesPreviewConciliacao.filter(a => a.tipo !== 3)[idx]);
                                                                        return acoesSelecaoIds.has(realIdx);
                                                                    })}
                                                                    onChange={(e) => {
                                                                        const novos = new Set<number>();
                                                                        if (e.target.checked) {
                                                                            acoesPreviewConciliacao.forEach((a, idx) => { if (a.tipo !== 3) novos.add(idx); });
                                                                        }
                                                                        setAcoesSelecaoIds(novos);
                                                                    }}
                                                                />
                                                            </th>
                                                            <th style={{ padding: '8px 10px', textAlign: 'left', borderBottom: '1px solid #e0e0e0' }}>Tipo</th>
                                                            <th style={{ padding: '8px 10px', textAlign: 'left', borderBottom: '1px solid #e0e0e0' }}>Descricao</th>
                                                            <th style={{ padding: '8px 10px', textAlign: 'left', borderBottom: '1px solid #e0e0e0' }}>Vencimento</th>
                                                            <th style={{ padding: '8px 10px', textAlign: 'right', borderBottom: '1px solid #e0e0e0' }}>Valor</th>
                                                            <th style={{ padding: '8px 10px', textAlign: 'left', borderBottom: '1px solid #e0e0e0' }}>Status Asaas</th>
                                                            <th style={{ padding: '8px 10px', textAlign: 'left', borderBottom: '1px solid #e0e0e0' }}>Motivo</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {acoesPreviewConciliacao.map((acao, idx) => {
                                                            const isDivergencia = acao.tipo === 3;
                                                            const selecionado = acoesSelecaoIds.has(idx);
                                                            const corBadge: Record<number, { bg: string; color: string }> = {
                                                                0: { bg: '#e3f2fd', color: '#1565c0' },
                                                                1: { bg: '#e8f5e9', color: '#2e7d32' },
                                                                2: { bg: '#fff3e0', color: '#e65100' },
                                                                3: { bg: '#fce4ec', color: '#b71c1c' },
                                                            };
                                                            const c = corBadge[acao.tipo] || { bg: '#eee', color: '#333' };
                                                            return (
                                                                <tr key={idx} style={{ borderBottom: '1px solid #f0f0f0', background: isDivergencia ? '#fff8f8' : undefined }}>
                                                                    <td style={{ padding: '8px 10px', textAlign: 'center' }}>
                                                                        {isDivergencia ? (
                                                                            <span style={{ fontSize: '0.7rem', color: '#b71c1c' }}>requer verificacao manual</span>
                                                                        ) : (
                                                                            <input
                                                                                type="checkbox"
                                                                                checked={selecionado}
                                                                                onChange={(e) => {
                                                                                    const novos = new Set(acoesSelecaoIds);
                                                                                    if (e.target.checked) novos.add(idx); else novos.delete(idx);
                                                                                    setAcoesSelecaoIds(novos);
                                                                                }}
                                                                            />
                                                                        )}
                                                                    </td>
                                                                    <td style={{ padding: '8px 10px' }}>
                                                                        <span style={{ background: c.bg, color: c.color, borderRadius: 12, padding: '2px 8px', fontWeight: 600, fontSize: '0.75rem', whiteSpace: 'nowrap' }}>
                                                                            {ROTULOS_ACAO_CONCILIACAO[acao.tipo] ?? acao.tipo}
                                                                        </span>
                                                                    </td>
                                                                    <td style={{ padding: '8px 10px' }}>{acao.descricao}</td>
                                                                    <td style={{ padding: '8px 10px', whiteSpace: 'nowrap' }}>
                                                                        {acao.vencimento ? new Date(acao.vencimento).toLocaleDateString('pt-BR') : '-'}
                                                                    </td>
                                                                    <td style={{ padding: '8px 10px', textAlign: 'right', whiteSpace: 'nowrap' }}>
                                                                        {acao.valor != null ? acao.valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) : '-'}
                                                                    </td>
                                                                    <td style={{ padding: '8px 10px', whiteSpace: 'nowrap' }}>
                                                                        <span style={{ fontSize: '0.78rem', color: '#555' }}>{acao.statusAsaas || '-'}</span>
                                                                    </td>
                                                                    <td style={{ padding: '8px 10px', color: '#666', maxWidth: 220, wordBreak: 'break-word' }}>{acao.motivo}</td>
                                                                </tr>
                                                            );
                                                        })}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </>
                                    )}
                                </>
                            )}

                            <div className="flex justify-end gap-2 mt-4">
                                <button
                                    className="px-4 py-2 text-sm text-gray-600 border border-gray-300 rounded-md hover:bg-gray-100"
                                    onClick={() => {
                                        previewConciliacaoCanceladoRef.current = true;
                                        setCarregandoPreviewConciliacao(false);
                                        setProgressoPreviewConciliacao(null);
                                        setShowModalConciliacaoAsaas(false);
                                    }}
                                    disabled={carregandoAplicarConciliacao}
                                >
                                    Fechar
                                </button>
                                {acoesPreviewConciliacao !== null && acoesPreviewConciliacao.length > 0 && (
                                    <button
                                        className="px-4 py-2 text-sm text-white rounded-md hover:opacity-90 disabled:opacity-50"
                                        style={{ backgroundColor: '#1F467E' }}
                                        onClick={handleAplicarConciliacaoAsaas}
                                        disabled={carregandoAplicarConciliacao || acoesSelecaoIds.size === 0}
                                    >
                                        {carregandoAplicarConciliacao ? 'Aplicando...' : `Aplicar selecionados (${acoesSelecaoIds.size})`}
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>
                )}

                <ModalAlertaTemporario
                    tempoEmSegundos={2}
                    show={exibirFormModalTemporario}
                    message={messageAlertaTemporario}
                    onHide={() => { setExibirFormModalTemporario(false) }}
                />

                <ModalAlerta
                    show={showAlerta}
                    message={messageAlerta}
                    onHide={() => setShowAlerta(false)}
                />
            </LocaSmartLayout>
        </>
    );
}

export default EmpresaListagem;
